import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';
import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.kiera.clusters');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from 'src/libs/portal/season/service';
import { TranslateService } from '@ngx-translate/core';

@Component({
 standalone: false,
 selector: 'wiz-page-kiera-clusters',
template: templateSource || '',
    styles: [``],
})
export class PageKieraClustersComponent implements OnInit, OnDestroy {
    public list: any[] = [];
    public total: number = 0;
    public search: any = { text: "", page: 1, dump: 20 };
    public pageSizeOptions: number[] = [10, 20, 50];

    public showAddModal: boolean = false;
    public wizardStep: number = 0;
    public wizardMode: string = '';
    public modalError: string = '';
    public loadingWizard: boolean = false;
    public creating: boolean = false;
    public newCluster: any = { name: '', provisioning_mode: 'direct', prefix: '', relay_prefix: '', compute_prefix: '', rack_unit: 1 };
    public bmcCredentialProfiles: any[] = [];
    public selectedBmcCredentialId: any = '';
    public clusterTemplateSelectedFile: File | null = null;
    public clusterTemplateSelectedFileName: string = '';
    public clusterTemplateFileSize: number = 0;
    public clusterTemplateFileType: string = '';
    public clusterTemplateUploadedAt: string = '';
    public clusterTemplateDraft: any = this.emptyClusterTemplateDraft();
    public clusterTemplateValidating: boolean = false;
    public clusterTemplateValidation: any = null;
    public clusterTemplateValidationTab: string = 'summary';
    public clusterTemplatePrefixTab: string = 'compute';
    public clusterTemplateMappingRules: any[] = this.defaultClusterTemplateMappingRules();
    public clusterTemplateMappingExpanded: any = {};
    public clusterTemplateMappingExecutedAt: string = '';
    public clusterTemplateMappingDurationLabel: string = '';

    public groups: any[] = [];
    public zones: any[] = [];
    public selectableNodes: any[] = [];
    public relaySubnets: any[] = [];
    public expandedGroups: any = {};
    public singleFilters: any = { bmc_type: '', status: '', group_id: '', rack: '' };
    public nodeFilter: any = this.emptyNodeFilter();
    public reviewNodes: any[] = [];
    public authoritySelection: any = {};
    public authoritySubnetSelection: any = {};
    public memberSelection: any = {};
    public selectedAuthorityNodeId: string = '';
    public memberAuthoritySelection: any = {};
    public lowerAuthoritySelection: any = {};
    public openActionId: any = null;

    public sortField: string = 'display_id';
    public sortDir: string = 'desc';

    private readonly bmcCredentialMessageType: string = 'kiera:bmc-credential-saved';

    private readonly onBmcCredentialWindowFocus = async () => {
        if (!this.showAddModal || !['manual', 'template'].includes(this.wizardMode)) return;
        await this.loadBmcCredentialProfiles();
        await this.service.render();
    };

    private readonly onBmcCredentialMessage = async (event: MessageEvent) => {
        if (event.origin !== window.location.origin || event.data?.type !== this.bmcCredentialMessageType) return;
        const credential = event.data?.credential;
        if (!credential || credential.id === undefined || credential.id === null) return;

        await this.loadBmcCredentialProfiles();
        this.selectedBmcCredentialId = credential.id;
        this.modalError = '';
        await this.service.render();
    };

    constructor(@Inject( Service) public service: Service,@Inject( TranslateService)  private translate: TranslateService) { }

    public async ngOnInit() {
        await this.service.init();
        window.addEventListener('focus', this.onBmcCredentialWindowFocus);
        window.addEventListener('message', this.onBmcCredentialMessage);
        await this.load();
        await this.service.render();
    }

    public ngOnDestroy() {
        window.removeEventListener('focus', this.onBmcCredentialWindowFocus);
        window.removeEventListener('message', this.onBmcCredentialMessage);
    }

    public async load(page: number = 1) {
        this.search.page = page;
        const { code, data } = await wiz.call("search", this.search);
        if (code === 200) {
            this.list = data.rows || [];
            this.total = data.total || 0;
            this.sortList();
        }
        await this.service.render();
    }

    public async openAddModal() {
        this.resetWizard();
        this.showAddModal = true;
        await this.loadWizardSources();
        await this.service.render();
    }

    public closeAddModal() {
        this.showAddModal = false;
        this.resetWizard();
    }

    public previousWizardStep() {
        if (this.wizardStep <= 0) {
            this.closeAddModal();
            return;
        }
        if (this.wizardMode === 'manual' && this.isManualDirectProvisioning() && this.wizardStep === 5) {
            this.wizardStep = 2;
        } else if (this.wizardMode === 'manual' && this.isManualDirectProvisioning() && (this.wizardStep === 3 || this.wizardStep === 4)) {
            this.wizardStep = 2;
        } else {
            this.wizardStep = this.wizardStep - 1;
        }
        this.modalError = '';
    }

    private resetWizard() {
        this.wizardStep = 0;
        this.wizardMode = '';
        this.modalError = '';
        this.loadingWizard = false;
        this.creating = false;
        this.newCluster = { name: '', provisioning_mode: 'direct', prefix: '', relay_prefix: '', compute_prefix: '', rack_unit: 1 };
        this.selectedBmcCredentialId = '';
        this.clusterTemplateSelectedFile = null;
        this.clusterTemplateSelectedFileName = '';
        this.clusterTemplateFileSize = 0;
        this.clusterTemplateFileType = '';
        this.clusterTemplateUploadedAt = '';
        this.clusterTemplateDraft = this.emptyClusterTemplateDraft();
        this.clusterTemplateValidating = false;
        this.clusterTemplateValidation = null;
        this.clusterTemplateValidationTab = 'summary';
        this.clusterTemplatePrefixTab = 'compute';
        this.clusterTemplateMappingRules = this.defaultClusterTemplateMappingRules();
        this.clusterTemplateMappingExpanded = {};
        this.clusterTemplateMappingExecutedAt = '';
        this.clusterTemplateMappingDurationLabel = '';
        this.singleFilters = { bmc_type: '', status: '', group_id: '', rack: '' };
        this.nodeFilter = this.emptyNodeFilter();
        this.reviewNodes = [];
        this.authoritySelection = {};
        this.authoritySubnetSelection = {};
        this.memberSelection = {};
        this.selectedAuthorityNodeId = '';
        this.memberAuthoritySelection = {};
        this.lowerAuthoritySelection = {};
        this.expandedGroups = {};
    }

    public clusterWizardSteps(): number[] {
        if (this.wizardMode === 'manual' && this.isManualDirectProvisioning()) {
            return [0, 1, 2, 5];
        }
        return [0, 1, 2, 3, 4, 5];
    }

    public clusterWizardStepNumber(step: number): number {
        const index = this.clusterWizardSteps().indexOf(Number(step || 0));
        return index >= 0 ? index : Number(step || 0);
    }

    public clusterWizardStepLabel(step: number): string {
        const manualLabels: any = {
            0: '생성 방식 선택',
            1: '클러스터 정보',
            2: '노드 선택',
            3: 'Authority 선택',
            4: 'Member 선택',
            5: '노드 이름 검토',
        };
        const templateLabels: any = {
            0: '생성 방식 선택',
            1: '템플릿 업로드',
            2: '템플릿 검증',
            3: '클러스터 정보',
            4: '노드 매핑',
            5: '클러스터 생성',
        };
        return (this.wizardMode === 'manual' ? manualLabels : templateLabels)[step] || '';
    }

    public clusterWizardHeaderTitle(): string {
        if (this.wizardMode === 'template' && this.wizardStep === 4) {
            return '클러스터 생성 > 노드 매핑 (Node Mapping)';
        }
        if (this.wizardMode === 'template' && this.wizardStep === 5) {
            return '클러스터 생성';
        }
        const suffix = this.wizardMode === 'template' && this.wizardStep > 0
            ? ` (${this.clusterWizardStepLabel(this.wizardStep)})`
            : '';
        return `Add cluster - ${this.clusterWizardStepNumber(this.wizardStep)}${suffix}`;
    }

    public clusterWizardHeaderSubtitle(): string {
        if (this.wizardMode === 'template' && this.wizardStep === 1) {
            return 'KiERA 표준 26컬럼 클러스터 템플릿 파일을 업로드하세요';
        }
        if (this.wizardMode === 'template' && this.wizardStep === 4) {
            return 'Node Identity Mapping Rule에 따라 템플릿 노드와 등록된 노드를 자동 매칭합니다.';
        }
        if (this.wizardMode === 'template' && this.wizardStep === 5) {
            return '입력한 정보를 확인하고 클러스터 생성을 시작합니다.';
        }
        return this.wizardStepTitle();
    }

    public async chooseClusterWizardMode(mode: string) {
        this.wizardMode = mode;
        this.modalError = '';
        await this.service.render();
    }

    public manualProvisioningMode(): string {
        return String(this.newCluster?.provisioning_mode || 'direct').trim().toLowerCase() === 'relay' ? 'relay' : 'direct';
    }

    public isManualDirectProvisioning(): boolean {
        return this.manualProvisioningMode() === 'direct';
    }

    public isManualRelayProvisioning(): boolean {
        return this.manualProvisioningMode() === 'relay';
    }

    public async setManualProvisioningMode(mode: string) {
        const nextMode = String(mode || '').trim().toLowerCase() === 'relay' ? 'relay' : 'direct';
        this.newCluster.provisioning_mode = nextMode;
        this.modalError = '';
        if (nextMode === 'direct') {
            this.newCluster.prefix = String(this.newCluster.compute_prefix || this.newCluster.prefix || '').trim();
            this.newCluster.relay_prefix = '';
            this.newCluster.compute_prefix = '';
            this.authoritySelection = {};
            this.authoritySubnetSelection = {};
            this.memberSelection = {};
            this.selectedAuthorityNodeId = '';
            this.memberAuthoritySelection = {};
            this.lowerAuthoritySelection = {};
            if (this.wizardStep === 3 || this.wizardStep === 4) this.wizardStep = 2;
        } else {
            if (!String(this.newCluster.compute_prefix || '').trim()) {
                this.newCluster.compute_prefix = String(this.newCluster.prefix || '').trim();
            }
            this.newCluster.prefix = String(this.newCluster.compute_prefix || '').trim();
        }
        await this.service.render();
    }

    public async startClusterManualWizard() {
        this.wizardMode = 'manual';
        this.newCluster.provisioning_mode = this.manualProvisioningMode();
        this.modalError = '';
        this.wizardStep = 1;
        await this.service.render();
    }

    public async startClusterTemplateWizard() {
        this.wizardMode = 'template';
        this.modalError = '';
        this.wizardStep = 1;
        await this.service.render();
    }

    public async startSelectedClusterWizardMode() {
        if (this.wizardMode === 'manual') {
            await this.startClusterManualWizard();
            return;
        }
        if (this.wizardMode === 'template') {
            await this.startClusterTemplateWizard();
            return;
        }
        this.modalError = 'Select creation method';
        await this.service.render();
    }

    private async loadBmcCredentialProfiles() {
        const { code, data } = await wiz.call('bmc_credentials');
        this.bmcCredentialProfiles = code === 200 && Array.isArray(data?.rows) ? data.rows : [];
        if (this.selectedBmcCredentialId !== '' && !this.selectedBmcCredentialProfile()) {
            this.selectedBmcCredentialId = '';
        }
    }

    public availableBmcCredentialProfiles(): any[] {
        return this.bmcCredentialProfiles.filter((item: any) => item.active !== false);
    }

    public selectedBmcCredentialProfile(): any {
        return this.availableBmcCredentialProfiles().find(
            (item: any) => String(item.id) === String(this.selectedBmcCredentialId)
        ) || null;
    }

    public async openNewBmcCredential() {
        this.modalError = '';
        const popup = window.open(
            '/kiera/bmc-credentials?mode=create&source=cluster',
            'kiera-bmc-credential-create',
            'width=1180,height=820,resizable=yes,scrollbars=yes'
        );
        if (!popup) {
            this.modalError = 'New BMC Credential 창을 열 수 없습니다. 브라우저의 팝업 허용 설정을 확인하세요.';
            await this.service.render();
            return;
        }
        popup.focus();
    }

    public async onClusterTemplateFileSelected(event: any) {
        const files = event?.target?.files;
        this.wizardMode = 'template';
        this.modalError = '';
        if (files && files.length > 0) {
            this.setClusterTemplateFile(files[0]);
        } else {
            this.setClusterTemplateFile(null);
        }
        await this.service.render();
    }

    public async onClusterTemplateFileDropped(event: any, fileInput?: any) {
        event?.preventDefault?.();
        event?.stopPropagation?.();
        const files = event?.dataTransfer?.files;
        this.wizardMode = 'template';
        this.modalError = '';
        if (files && files.length > 0) {
            this.setClusterTemplateFile(files[0]);
            if (fileInput) fileInput.value = '';
        }
        await this.service.render();
    }

    private setClusterTemplateFile(file: File | null) {
        if (!file) {
            this.clusterTemplateSelectedFile = null;
            this.clusterTemplateSelectedFileName = '';
            this.clusterTemplateFileSize = 0;
            this.clusterTemplateFileType = '';
            this.clusterTemplateUploadedAt = '';
            this.clusterTemplateValidation = null;
            this.clusterTemplateDraft = this.emptyClusterTemplateDraft();
            this.clusterTemplatePrefixTab = 'compute';
            this.clusterTemplateMappingExpanded = {};
            this.clusterTemplateMappingExecutedAt = '';
            this.clusterTemplateMappingDurationLabel = '';
            return;
        }

        const extension = this.fileExtension(file.name);
        const allowed = ['.xlsx', '.xlsm', '.xltx', '.csv', '.tsv', '.txt', '.xls', '.xml', '.html', '.htm'];
        if (!allowed.includes(extension)) {
            this.clusterTemplateSelectedFile = null;
            this.clusterTemplateSelectedFileName = '';
            this.clusterTemplateFileSize = 0;
            this.clusterTemplateFileType = '';
            this.clusterTemplateUploadedAt = '';
            this.clusterTemplateValidation = null;
            this.clusterTemplateDraft = this.emptyClusterTemplateDraft();
            this.clusterTemplatePrefixTab = 'compute';
            this.clusterTemplateMappingExpanded = {};
            this.clusterTemplateMappingExecutedAt = '';
            this.clusterTemplateMappingDurationLabel = '';
            this.modalError = '지원하지 않는 템플릿 파일 형식입니다.';
            return;
        }

        this.clusterTemplateDraft = this.emptyClusterTemplateDraft();
        this.clusterTemplateSelectedFile = file;
        this.clusterTemplateSelectedFileName = file.name || '';
        this.clusterTemplateFileSize = Number(file.size || 0);
        this.clusterTemplateFileType = file.type || this.clusterTemplateFileFormatLabel;
        this.clusterTemplateUploadedAt = this.formatDateTime(new Date());
        this.clusterTemplateValidation = null;
        this.clusterTemplateValidationTab = 'summary';
        this.clusterTemplatePrefixTab = 'compute';
        this.clusterTemplateMappingExpanded = {};
        this.clusterTemplateMappingExecutedAt = '';
        this.clusterTemplateMappingDurationLabel = '';
    }

    private fileExtension(fileName: string): string {
        const match = String(fileName || '').toLowerCase().match(/\.[^.]+$/);
        return match ? match[0] : '';
    }

    private formatDateTime(date: Date): string {
        const pad = (value: number) => String(value).padStart(2, '0');
        return [
            date.getFullYear(),
            pad(date.getMonth() + 1),
            pad(date.getDate()),
        ].join('-') + ' ' + [
            pad(date.getHours()),
            pad(date.getMinutes()),
            pad(date.getSeconds()),
        ].join(':');
    }

    public formatClusterTemplateFileSize(size: any): string {
        const bytes = Number(size || 0);
        if (!bytes) return '-';
        if (bytes >= 1024 * 1024) return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
        if (bytes >= 1024) return `${Math.round(bytes / 1024)} KB`;
        return `${bytes} B`;
    }

    private async readClusterTemplateFileAsBase64(file: File): Promise<string> {
        const buffer = await file.arrayBuffer();
        const bytes = new Uint8Array(buffer);
        const chunkSize = 0x8000;
        let binary = '';
        for (let index = 0; index < bytes.length; index += chunkSize) {
            const chunk = bytes.subarray(index, index + chunkSize);
            binary += String.fromCharCode(...Array.from(chunk));
        }
        return btoa(binary);
    }

    private downloadBase64File(contentBase64: string, filename: string, mimeType: string) {
        const encoded = String(contentBase64 || '');
        const binary = atob(encoded.includes(',') ? encoded.split(',').pop() || '' : encoded);
        const bytes = new Uint8Array(binary.length);
        for (let index = 0; index < binary.length; index++) {
            bytes[index] = binary.charCodeAt(index);
        }
        const blob = new Blob([bytes], { type: mimeType || 'application/octet-stream' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    private applyClusterTemplateValidation(preview: any) {
        this.clusterTemplateValidation = preview || null;
        const cluster = this.clusterTemplateValidation?.cluster || {};
        const draft = this.emptyClusterTemplateDraft();
        draft.name = String(cluster.name || '').trim();
        draft.group_name = draft.name;
        draft.description = String(cluster.description || '').trim();
        const legacyPrefix = String(cluster.cluster_prefix || cluster.node_prefix || cluster.prefix || '').trim();
        draft.relay_prefix = String(cluster.relay_prefix || '').trim();
        draft.compute_prefix = String(cluster.compute_prefix || legacyPrefix).trim();
        draft.cluster_prefix = legacyPrefix || draft.compute_prefix;
        draft.prefix = draft.compute_prefix;
        draft.rack_unit = this.clusterTemplateFirstInteger(cluster.nodes_per_rack) || Number(this.clusterTemplateValidation?.summary?.total_nodes || 0) || 1;
        draft.provisioning_mode = this.normalizeClusterTemplateProvisioningMode(cluster.provisioning_mode)
            || (Number(this.clusterTemplateValidation?.summary?.relay_count || 0) > 0 ? 'relay' : 'direct');
        draft.template_version = String(cluster.template_version || '').trim();
        draft.prefix_padding = String(cluster.prefix_number_padding || cluster.prefix_padding || '').trim();
        draft.starting_number = String(cluster.starting_number || '').trim();
        this.clusterTemplateDraft = draft;
        const file = this.clusterTemplateValidation?.file || {};
        if (file.uploaded) this.clusterTemplateUploadedAt = file.uploaded;
        this.clusterTemplateMappingExpanded = {};
        this.clusterTemplateMappingExecutedAt = this.formatDateTime(new Date());
        this.clusterTemplateMappingDurationLabel = '00:00:00';
    }

    private emptyClusterTemplateDraft(): any {
        return {
            name: '',
            group_name: '',
            description: '',
            prefix: '',
            cluster_prefix: '',
            relay_prefix: '',
            compute_prefix: '',
            rack_unit: '',
            provisioning_mode: '',
            template_version: '',
            prefix_padding: '',
            starting_number: '',
        };
    }

    private clusterTemplateFirstInteger(value: any): any {
        const text = String(value ?? '').trim();
        if (!text) return '';
        const match = text.match(/\d+/);
        if (!match) return '';
        const numeric = Number(match[0]);
        return numeric > 0 ? numeric : '';
    }

    private normalizeClusterTemplateProvisioningMode(value: any): string {
        const text = String(value || '').trim().toLowerCase();
        if (!text) return '';
        if (text.includes('relay') || text.includes('릴레이') || text.includes('중계')) return 'relay';
        if (text.includes('direct') || text.includes('manual') || text.includes('직접')) return 'direct';
        return '';
    }

    public isClusterTemplateRelayMode(): boolean {
        return this.clusterTemplateDraft?.provisioning_mode === 'relay';
    }

    public clusterTemplateProvisioningModeLabel(): string {
        if (this.clusterTemplateDraft?.provisioning_mode === 'relay') return 'Relay Provisioning';
        if (this.clusterTemplateDraft?.provisioning_mode === 'direct') return 'Direct Provisioning';
        return '-';
    }

    public clusterTemplatePrefixTabs(): any[] {
        return [];
    }

    public setClusterTemplatePrefixTab(tab: string) {
        this.clusterTemplatePrefixTab = tab === 'relay' && this.isClusterTemplateRelayMode() ? 'relay' : 'compute';
        this.service.render();
    }

    public clusterTemplatePaddingLabel(): string {
        const padding = Number(this.clusterTemplateDraft?.prefix_padding || 0);
        if (!padding) return '-';
        return `${padding} (${String(1).padStart(padding, '0')})`;
    }

    private clusterTemplateRelayPrefix(): string {
        return String(this.clusterTemplateDraft?.relay_prefix || '').trim();
    }

    private clusterTemplateComputePrefix(): string {
        return String(this.clusterTemplateDraft?.compute_prefix || this.clusterTemplateDraft?.cluster_prefix || this.clusterTemplateDraft?.prefix || '').trim();
    }

    private clusterTemplateSequenceNumber(offset: number = 0): number {
        return Math.max(1, offset + 1);
    }

    private clusterTemplateFormatSequence(number: number): string {
        return String(Math.max(1, Number(number || 1)));
    }

    private clusterTemplateRelayHostname(offset: number = 0): string {
        return this.clusterTemplateGeneratedHostname(this.clusterTemplateRelayPrefix(), offset);
    }

    private clusterTemplateComputeHostname(offset: number = 0): string {
        return this.clusterTemplateGeneratedHostname(this.clusterTemplateComputePrefix(), offset);
    }

    private clusterTemplateLowerHostname(authorityNumber: any, childOffset: number = 0): string {
        return this.clusterTemplateComputeHostname(childOffset);
    }

    private clusterTemplateGeneratedHostname(prefix: any, offset: number = 0): string {
        const text = String(prefix || '').trim();
        if (!text) return '';
        const padding = Number(this.clusterTemplateDraft?.prefix_padding || 0);
        const start = Number(this.clusterTemplateDraft?.starting_number || 1);
        const number = Math.max(0, start + offset);
        const suffix = padding > 0 ? String(number).padStart(padding, '0') : String(number);
        return `${text}${suffix}`;
    }

    public clusterTemplatePrefixExample(prefix: any): string {
        const text = String(prefix || '').trim();
        if (!text) return '-';
        return `${this.clusterTemplateGeneratedHostname(text, 0)}, ${this.clusterTemplateGeneratedHostname(text, 1)} ...`;
    }

    public clusterTemplatePrefixExampleText(): string {
        const relayPrefix = this.clusterTemplateRelayPrefix();
        const computePrefix = this.clusterTemplateComputePrefix();
        const examples: string[] = [];
        if (relayPrefix) examples.push(`Relay Prefix=${relayPrefix} → ${this.clusterTemplatePrefixExample(relayPrefix)}`);
        if (computePrefix) {
            const label = this.isClusterTemplateRelayMode() ? 'Compute Prefix' : 'Node Prefix';
            examples.push(`${label}=${computePrefix} → ${this.clusterTemplatePrefixExample(computePrefix)}`);
        }
        if (!examples.length) return 'Node Prefix를 입력하면 Hostname 예시가 표시됩니다.';
        return `예시: ${examples.join(' / ')}`;
    }

    public get clusterTemplateStep3SummaryRows(): any[] {
        const bmcCredential = this.selectedBmcCredentialProfile();
        return [
            { label: 'Cluster Name', value: this.clusterTemplateDraft?.name || '-' },
            { label: 'Description', value: this.clusterTemplateDraft?.description || '-' },
            { label: 'Nodes per Rack', value: this.clusterTemplateDraft?.rack_unit || '-' },
            { label: 'BMC Credential', value: bmcCredential?.name || '-' },
            { label: 'Provisioning Mode', value: this.clusterTemplateProvisioningModeLabel(), badge: this.clusterTemplateDraft?.provisioning_mode },
        ];
    }

    public get clusterTemplateStep3PrefixRows(): any[] {
        const rows: any[] = [];
        if (this.isClusterTemplateRelayMode()) {
            rows.push({
                label: 'Relay Node Prefix',
                value: this.clusterTemplateDraft?.relay_prefix || '-',
                sub: this.clusterTemplateDraft?.relay_prefix ? this.clusterTemplatePrefixExample(this.clusterTemplateDraft?.relay_prefix) : '',
            });
        }
        rows.push(
            {
                label: this.isClusterTemplateRelayMode() ? 'Compute Node Prefix' : 'Node Prefix',
                value: this.clusterTemplateComputePrefix() || '-',
                sub: this.clusterTemplateComputePrefix() ? this.clusterTemplatePrefixExample(this.clusterTemplateComputePrefix()) : '',
            },
            {
                label: 'Prefix Number Padding',
                value: this.clusterTemplatePaddingLabel(),
            },
            {
                label: 'Starting Number',
                value: this.clusterTemplateDraft?.starting_number || '-',
            },
        );
        return rows;
    }

    private validateClusterTemplateInfo(): boolean {
        const draft = this.clusterTemplateDraft || {};
        draft.name = String(draft.name || '').trim();
        draft.group_name = draft.name;
        draft.description = String(draft.description || '').trim();
        draft.relay_prefix = String(draft.relay_prefix || '').trim();
        draft.compute_prefix = String(draft.compute_prefix || draft.cluster_prefix || draft.prefix || '').trim();
        draft.cluster_prefix = draft.compute_prefix;
        draft.prefix = draft.compute_prefix;
        draft.rack_unit = this.clusterTemplateFirstInteger(draft.rack_unit);
        draft.prefix_padding = String(draft.prefix_padding ?? '').trim();
        draft.starting_number = String(draft.starting_number ?? '').trim();
        if (!draft.name) {
            this.modalError = 'Cluster Name을 입력하세요.';
            return false;
        }
        if (!draft.rack_unit) {
            this.modalError = 'Nodes per Rack 값을 입력하세요.';
            return false;
        }
        if (this.selectedBmcCredentialId !== '' && !this.selectedBmcCredentialProfile()) {
            this.modalError = '유효한 BMC Credential을 선택하세요.';
            return false;
        }
        if (!draft.provisioning_mode) {
            this.modalError = '템플릿의 Provisioning Mode 값을 확인하세요.';
            return false;
        }
        if (draft.provisioning_mode === 'relay' && !draft.relay_prefix) {
            this.modalError = 'Relay Node Prefix를 입력하세요.';
            return false;
        }
        if (!draft.compute_prefix) {
            this.modalError = this.isClusterTemplateRelayMode() ? 'Compute Node Prefix를 입력하세요.' : 'Node Prefix를 입력하세요.';
            return false;
        }
        if (draft.prefix_padding) {
            const padding = Number(draft.prefix_padding);
            if (!Number.isInteger(padding) || padding < 0 || padding > 12) {
                this.modalError = 'Prefix Number Padding은 0에서 12 사이의 정수로 입력하세요.';
                return false;
            }
            draft.prefix_padding = padding;
        }
        if (draft.starting_number) {
            const start = Number(draft.starting_number);
            if (!Number.isInteger(start) || start < 1) {
                this.modalError = 'Starting Number는 1 이상의 정수로 입력하세요.';
                return false;
            }
            draft.starting_number = start;
        }
        if (!draft.prefix_padding) draft.prefix_padding = '';
        if (!draft.starting_number) draft.starting_number = '';
        if (!draft.relay_prefix && draft.provisioning_mode !== 'relay') {
            draft.relay_prefix = '';
        }
        if (!draft.cluster_prefix) {
            this.modalError = this.isClusterTemplateRelayMode() ? 'Compute Node Prefix를 입력하세요.' : 'Node Prefix를 입력하세요.';
            return false;
        }
        return true;
    }

    public async validateClusterTemplate(): Promise<boolean> {
        if (!this.clusterTemplateSelectedFile) {
            this.modalError = '템플릿 파일을 선택하세요.';
            return false;
        }
        this.clusterTemplateValidating = true;
        this.modalError = '';
        await this.service.render();
        try {
            const contentBase64 = await this.readClusterTemplateFileAsBase64(this.clusterTemplateSelectedFile);
            const { code, data } = await wiz.call("template_validate", {
                filename: this.clusterTemplateSelectedFileName || this.clusterTemplateSelectedFile.name || 'cluster-template.xlsx',
                uploaded: this.clusterTemplateUploadedAt,
                content_base64: contentBase64,
            });
            if (code !== 200) {
                this.modalError = data?.message || '템플릿 검증에 실패했습니다.';
                this.clusterTemplateValidating = false;
                await this.service.render();
                return false;
            }
            this.applyClusterTemplateValidation(data?.preview || data);
            this.clusterTemplateValidationTab = 'summary';
            this.clusterTemplateValidating = false;
            await this.service.render();
            return true;
        } catch (error: any) {
            this.modalError = error?.message || '템플릿 검증에 실패했습니다.';
            this.clusterTemplateValidating = false;
            await this.service.render();
            return false;
        }
    }

    public get hasClusterTemplateUpload(): boolean {
        return !!this.clusterTemplateSelectedFileName;
    }

    public get clusterTemplateFileFormatLabel(): string {
        const extension = this.fileExtension(this.clusterTemplateSelectedFileName);
        if (['.xlsx', '.xlsm', '.xltx'].includes(extension)) return 'Excel OOXML 파일';
        if (extension === '.xls') return 'XLS 파일';
        if (['.csv', '.tsv', '.txt'].includes(extension)) return '구분자 텍스트 파일';
        if (['.xml', '.html', '.htm'].includes(extension)) return 'Excel XML/HTML 파일';
        return '템플릿 파일';
    }

    public get clusterTemplateRecommendedName(): string {
        return 'Direct/Relay XLSX 샘플 중 선택';
    }

    public get clusterTemplateInfoRows(): any[] {
        const file = this.clusterTemplateValidation?.file || {};
        const summary = this.clusterTemplateValidation?.summary || {};
        const isRelay = this.isClusterTemplateRelayMode();
        return [
            { label: '템플릿 형식', value: 'KiERA Cluster Template (25 columns)' },
            { label: '시트 구성', value: 'KiERA_Cluster_Template 단일 시트: Cluster Information + Node Inventory' },
            { label: 'Cluster Information', value: 'Template Version부터 Provisioning Mode까지 8개 항목' },
            { label: 'Node Inventory', value: 'Role부터 Comment까지 25개 컬럼' },
            { label: 'Role 값', value: 'authority, member, compute' },
            { label: '미등록 노드', value: '템플릿 정보로 Node를 생성한 뒤 클러스터에 포함' },
            { label: '매핑 기준', value: 'Node ID, Hostname, BMC/Provisioning IP·MAC 등 식별값' },
            { label: '시트명', value: file.sheet_name || (this.hasClusterTemplateUpload ? '검증 대기' : '-') },
            { label: '노드 데이터 행 수', value: summary.total_nodes ?? (this.hasClusterTemplateUpload ? '검증 대기' : '-') },
            { label: '릴레이 후보 수', value: summary.relay_count ?? (this.hasClusterTemplateUpload ? '검증 대기' : '-') },
            { label: '계산노드 후보 수', value: summary.compute_count ?? (this.hasClusterTemplateUpload ? '검증 대기' : '-') },
            { label: 'Relay Node Prefix', value: isRelay ? (this.clusterTemplateValidation?.cluster?.relay_prefix || this.clusterTemplateDraft?.relay_prefix || (this.hasClusterTemplateUpload ? '검증 대기' : '-')) : 'Direct 샘플에서는 사용 안함' },
            { label: isRelay ? 'Compute Node Prefix' : 'Node Prefix', value: this.clusterTemplateValidation?.cluster?.compute_prefix || this.clusterTemplateValidation?.cluster?.node_prefix || this.clusterTemplateDraft?.compute_prefix || (this.hasClusterTemplateUpload ? '검증 대기' : '-') },
            { label: '클러스터/그룹', value: this.hasClusterTemplateUpload ? 'cluster_name 값으로 자동 설정' : '-' },
            { label: '기본값', value: this.hasClusterTemplateUpload ? 'Rack=노드 수, Mode=샘플의 provisioning_mode 우선' : '-' },
            { label: '생성자', value: 'Admin' },
            { label: '생성 일시', value: this.clusterTemplateUploadedAt || '-' },
        ];
    }

    public get clusterTemplateValidationItems(): any[] {
        if (!this.hasClusterTemplateUpload) return [];
        if (this.clusterTemplateValidation?.checks) {
            return this.clusterTemplateValidation.checks.map((item: any) => ({
                label: item.name,
                status: item.status === 'success' ? 'normal' : item.status,
                result: item.detail || '',
                description: item.description || '',
            }));
        }
        return [
            { label: '클러스터 정보 매핑', status: 'normal', result: 'Direct/Relay 샘플별 Cluster Info 입력' },
            { label: 'BMC IP 노드 매핑', status: 'pending', result: '다음 단계 검증' },
            { label: '역할 정보', status: 'normal', result: 'authority/member/compute 업로드됨' },
            { label: '서브넷 정보', status: 'pending', result: '다음 단계 검증' },
            { label: '매칭 노드 정보 보강', status: 'normal', result: '다음 단계에서 KiERA DB 기준 보강' },
        ];
    }

    public get clusterTemplateValidationSummaryCards(): any[] {
        if (this.clusterTemplateValidation?.summary) {
            const summary = this.clusterTemplateValidation.summary;
            const total = Number(summary.total_nodes || 0);
            return [
                { label: '전체 노드', value: total, sub: '', tone: 'neutral', icon: 'bx-server' },
                { label: '릴레이', value: summary.relay_count || 0, sub: '', tone: 'normal', icon: 'bx-git-branch' },
                { label: '경고', value: summary.warnings || 0, sub: '', tone: 'warning', icon: 'bx-error' },
                { label: '오류', value: summary.errors || 0, sub: '', tone: 'error', icon: 'bx-error-circle' },
            ];
        }
        const items = this.clusterTemplateValidationItems;
        const total = items.length;
        const normal = items.filter((item: any) => item.status === 'normal').length;
        const warning = items.filter((item: any) => item.status === 'warning').length;
        const error = items.filter((item: any) => item.status === 'error').length;
        const pending = Math.max(total - normal - warning - error, 0);
        return [
            { label: '전체 항목', value: total, sub: '', tone: 'neutral', icon: 'bx-check-circle' },
            { label: '업로드됨', value: normal, sub: `${this.percent(normal, total)}%`, tone: 'normal', icon: 'bx-check-circle' },
            { label: '검증 대기', value: pending, sub: `${this.percent(pending, total)}%`, tone: 'neutral', icon: 'bx-time-five' },
            { label: '오류', value: error, sub: `${this.percent(error, total)}%`, tone: 'error', icon: 'bx-error-circle' },
        ];
    }

    public get clusterTemplateWarningDetails(): any[] {
        if (!this.hasClusterTemplateUpload) return [];
        if (this.clusterTemplateValidation?.details) {
            return this.clusterTemplateValidation.details
                .filter((item: any) => item.level !== 'error')
                .map((item: any) => ({
                    row: item.row || '-',
                    sheet: item.sheet || '-',
                    column: item.column || '-',
                    content: item.content || '-',
                    message: item.message || '-',
                }));
        }
        return [
            {
                row: '-',
                sheet: 'Template',
                column: 'Direct: cluster_name,node_prefix,prefix_number_padding,starting_number/bmc_ip | Relay: cluster_name,relay_node_prefix,compute_node_prefix,prefix_number_padding,starting_number/bmc_ip,role,subnet_name',
                content: '검증 대기',
                message: 'Cluster Info와 Node Inventory 최소 컬럼 검증은 다음 단계에서 진행됩니다.',
            },
            {
                row: '-',
                sheet: 'Template',
                column: 'bmc_ip',
                content: '검증 대기',
                message: 'BMC IP를 기준으로 KiERA DB 노드 정보와 대조됩니다.',
            },
        ];
    }

    private percent(value: number, total: number): string {
        if (!total) return '0';
        return ((value / total) * 100).toFixed(1);
    }

    public get clusterTemplateStep2SummaryRows(): any[] {
        const summary = this.clusterTemplateValidation?.summary || {};
        return [
            { label: '전체 노드 수', value: summary.total_nodes ?? 0, icon: 'bx-data', tone: 'text-zinc-600' },
            { label: '릴레이 노드 수', value: summary.relay_count ?? 0, icon: 'bx-git-branch', tone: 'text-zinc-600' },
            { label: '계산 노드 수', value: summary.compute_count ?? 0, icon: 'bx-server', tone: 'text-zinc-600' },
            { label: '경고', value: summary.warnings ?? 0, icon: 'bx-error', tone: 'text-amber-600' },
            { label: '오류', value: summary.errors ?? 0, icon: 'bx-error-circle', tone: 'text-red-600' },
        ];
    }

    public get clusterTemplateStep2Result(): any {
        const summary = this.clusterTemplateValidation?.summary || {};
        return {
            status: summary.result_status || 'success',
            title: summary.result_title || '성공',
            message: summary.result_message || '템플릿 검증이 완료되었습니다.',
        };
    }

    public get clusterTemplateStep2ClusterRows(): any[] {
        const cluster = this.clusterTemplateValidation?.cluster || {};
        const rows = [
            { label: 'Cluster Name', value: cluster.name || this.clusterTemplateDraft.name || '-' },
            { label: 'Description', value: cluster.description || '-' },
            ...(this.isClusterTemplateRelayMode() ? [{ label: 'Relay Node Prefix', value: cluster.relay_prefix || this.clusterTemplateDraft.relay_prefix || '-' }] : []),
            { label: this.isClusterTemplateRelayMode() ? 'Compute Node Prefix' : 'Node Prefix', value: cluster.compute_prefix || cluster.cluster_prefix || cluster.node_prefix || this.clusterTemplateDraft.compute_prefix || '-' },
            { label: 'Prefix Number Padding', value: cluster.prefix_number_padding || this.clusterTemplateDraft.prefix_padding || '-' },
            { label: 'Starting Number', value: cluster.starting_number || this.clusterTemplateDraft.starting_number || '-' },
            { label: 'Nodes per Rack', value: cluster.nodes_per_rack || this.clusterTemplateDraft.rack_unit || '-' },
            { label: 'Provisioning Mode', value: cluster.provisioning_mode || this.clusterTemplateProvisioningModeLabel(), badge: true },
            { label: 'Template Version', value: cluster.template_version || '-' },
        ];
        return rows;
    }

    public get clusterTemplateStep2Metrics(): any[] {
        return this.clusterTemplateValidation?.metrics || [];
    }

    public clusterTemplateStep2MetricIcon(metric: any): string {
        if (metric?.status === 'success') return 'bx-check-circle text-emerald-600';
        if (metric?.status === 'warning') return 'bx-error text-amber-500';
        if (metric?.status === 'error') return 'bx-error-circle text-red-500';
        return 'bx-info-circle text-zinc-400';
    }

    public clusterTemplateStep2MetricLabel(metric: any): string {
        if (metric?.status === 'success') return '모두 통과';
        if (metric?.status === 'warning') return '경고';
        if (metric?.status === 'error') return '오류';
        return '대기';
    }

    public get clusterTemplateStep2Tabs(): any[] {
        const details = this.clusterTemplateValidation?.details || [];
        return [
            { key: 'summary', label: '전체 요약', count: '' },
            { key: 'error', label: '오류', count: details.filter((item: any) => item.level === 'error').length },
            { key: 'warning', label: '경고', count: details.filter((item: any) => item.level === 'warning').length },
            { key: 'details', label: '상세 결과', count: '' },
        ];
    }

    public get clusterTemplateStep2Checks(): any[] {
        const checks = this.clusterTemplateValidation?.checks || [];
        if (this.clusterTemplateValidationTab === 'error') return checks.filter((item: any) => item.status === 'error');
        if (this.clusterTemplateValidationTab === 'warning') return checks.filter((item: any) => item.status === 'warning');
        return checks;
    }

    public get clusterTemplateStep2Details(): any[] {
        const details = this.clusterTemplateValidation?.details || [];
        if (this.clusterTemplateValidationTab === 'error') return details.filter((item: any) => item.level === 'error');
        if (this.clusterTemplateValidationTab === 'warning') return details.filter((item: any) => item.level === 'warning');
        return details;
    }

    public get clusterTemplateStep2FileRows(): any[] {
        const file = this.clusterTemplateValidation?.file || {};
        return [
            { label: '파일명', value: file.name || this.clusterTemplateSelectedFileName || '-' },
            { label: '업로드 시간', value: file.uploaded || this.clusterTemplateUploadedAt || '-' },
            { label: '파일 크기', value: this.formatClusterTemplateFileSize(file.size || this.clusterTemplateFileSize) },
            { label: '시트명', value: file.sheet_name || '-' },
        ];
    }

    public clusterTemplateCheckStatusClass(status: string): string {
        if (status === 'success' || status === 'normal') return 'text-emerald-700';
        if (status === 'warning') return 'text-amber-700';
        if (status === 'error') return 'text-red-700';
        return 'text-zinc-600';
    }

    public clusterTemplateCheckStatusIcon(status: string): string {
        if (status === 'success' || status === 'normal') return 'bx-check-circle';
        if (status === 'warning') return 'bx-error';
        if (status === 'error') return 'bx-error-circle';
        return 'bx-info-circle';
    }

    public clusterTemplateCheckStatusLabel(status: string): string {
        if (status === 'success' || status === 'normal') return '성공';
        if (status === 'warning') return '경고';
        if (status === 'error') return '오류';
        return '대기';
    }

    public clusterTemplateSummaryCardClass(tone: string): string {
        if (tone === 'normal') return 'border-emerald-100 text-emerald-700';
        if (tone === 'warning') return 'border-amber-100 text-amber-600';
        if (tone === 'error') return 'border-red-100 text-red-600';
        return 'border-zinc-200 text-zinc-700';
    }

    public clusterTemplateStatusBadgeClass(status: string): string {
        if (status === 'normal') return 'bg-emerald-100 text-emerald-700';
        if (status === 'warning') return 'bg-amber-100 text-amber-700';
        if (status === 'error') return 'bg-red-100 text-red-700';
        return 'bg-zinc-100 text-zinc-600';
    }

    public clusterTemplateStatusIcon(status: string): string {
        if (status === 'normal') return 'bx-check-circle';
        if (status === 'warning') return 'bx-error';
        if (status === 'error') return 'bx-error-circle';
        return 'bx-info-circle';
    }

    public clusterTemplateStatusLabel(status: string): string {
        if (status === 'normal') return '정상';
        if (status === 'warning') return '경고';
        if (status === 'error') return '오류';
        return '대기';
    }

    private defaultClusterTemplateMappingRules(): any[] {
        return this.clusterTemplateMappingRuleOptions()
            .slice(0, 5)
            .map((option: any) => ({ ...option }));
    }

    public clusterTemplateMappingRuleOptions(): any[] {
        return [
            { key: 'bmc_ip', label: 'BMC IP Address', shortLabel: 'BMC IP', description: 'BMC(관리망) IP 주소' },
            { key: 'node_id', label: 'KiERA Node ID', shortLabel: 'Node ID', description: 'KiERA에 등록된 노드 ID' },
            { key: 'bmc_mac', label: 'BMC MAC Address', shortLabel: 'BMC MAC', description: 'BMC(관리망) MAC 주소' },
            { key: 'provisioning_mac', label: 'Provisioning MAC Address', shortLabel: 'Prov. MAC', description: '프로비저닝 NIC MAC 주소' },
            { key: 'hostname', label: 'Hostname', shortLabel: 'Hostname', description: '호스트명' },
            { key: 'serial_number', label: 'System Serial Number', shortLabel: 'Serial', description: '시스템 시리얼 번호' },
        ];
    }

    public clusterTemplateMappingRuleOptionsFor(rule: any): any[] {
        const currentKey = rule?.key;
        const used = new Set(
            (this.clusterTemplateMappingRules || [])
                .filter((item: any) => item !== rule)
                .map((item: any) => item.key)
        );
        return this.clusterTemplateMappingRuleOptions()
            .filter((option: any) => option.key === currentKey || !used.has(option.key));
    }

    public onClusterTemplateMappingRuleChanged(rule: any) {
        const option = this.clusterTemplateMappingRuleOptions().find((item: any) => item.key === rule.key);
        if (option) {
            rule.label = option.label;
            rule.shortLabel = option.shortLabel;
            rule.description = option.description;
        }
        this.service.render();
    }

    public addClusterTemplateMappingRule() {
        const used = new Set((this.clusterTemplateMappingRules || []).map((rule: any) => rule.key));
        const option = this.clusterTemplateMappingRuleOptions().find((item: any) => !used.has(item.key));
        if (!option) return;
        this.clusterTemplateMappingRules.push({ ...option });
        this.service.render();
    }

    public removeClusterTemplateMappingRule(index: number) {
        if ((this.clusterTemplateMappingRules || []).length <= 1) return;
        this.clusterTemplateMappingRules.splice(index, 1);
        this.service.render();
    }

    public async runClusterTemplateNodeMapping() {
        const started = Date.now();
        this.clusterTemplateMappingExecutedAt = this.formatDateTime(new Date());
        this.clusterTemplateMappingDurationLabel = this.formatClusterTemplateMappingDuration(Date.now() - started);
        await this.service.render();
    }

    private formatClusterTemplateMappingDuration(durationMs: number): string {
        const seconds = Math.max(0, Math.floor(Number(durationMs || 0) / 1000));
        const pad = (value: number) => String(value).padStart(2, '0');
        return `${pad(Math.floor(seconds / 3600))}:${pad(Math.floor((seconds % 3600) / 60))}:${pad(seconds % 60)}`;
    }

    private normalizedClusterTemplateMappingValue(value: any, kind: string): string {
        const text = String(value ?? '').trim();
        if (!text) return '';
        if (kind === 'bmc_mac' || kind === 'provisioning_mac') {
            const normalized = text.replace(/[^0-9A-Fa-f]/g, '').toLowerCase();
            return normalized.length === 12 ? normalized : '';
        }
        if (kind === 'node_id') return /^\d+$/.test(text) ? String(Number(text)) : text;
        if (kind === 'hostname' || kind === 'serial_number') return text.toLowerCase();
        return text;
    }

    private clusterTemplateIdentityValue(node: any, key: string): string {
        const source: any = {
            node_id: node?.template_node_id || node?.node_id,
            bmc_mac: node?.template_bmc_mac,
            provisioning_mac: node?.template_provisioning_mac,
            bmc_ip: node?.template_bmc_ip,
            hostname: node?.template_hostname,
            serial_number: node?.template_serial_number,
        };
        return this.normalizedClusterTemplateMappingValue(source[key], key);
    }

    private inventoryIdentityValue(node: any, key: string): string {
        const source: any = {
            node_id: node?.id,
            bmc_mac: node?.bmc_mac,
            provisioning_mac: node?.mac_address,
            bmc_ip: node?.bmc_ip,
            hostname: node?.name,
            serial_number: node?.serial_number,
        };
        return this.normalizedClusterTemplateMappingValue(source[key], key);
    }

    private clusterTemplateRoleType(node: any): string {
        const roleType = String(node?.role_type || '').trim().toLowerCase();
        if (roleType === 'relay') return 'relay';
        const role = String(node?.role || '').trim().toLowerCase();
        if (['relay', 'authority', 'member', 'dhcp', 'server', '멤버'].some((token: string) => role.includes(token))) return 'relay';
        return 'compute';
    }

    private clusterTemplateHostname(node: any, index: number): string {
        const explicitName = String(node?.template_hostname || '').trim();
        if (explicitName) return explicitName;
        const roleType = this.clusterTemplateRoleType(node);
        if (roleType === 'relay') return this.clusterTemplateRelayHostname(index) || '-';
        return this.clusterTemplateComputeHostname(index) || '-';
    }

    private clusterTemplateIpSortParts(row: any): number[] {
        const ip = String(row?.template_bmc_ip || row?.matched_node?.bmc_ip || '').trim();
        const parts = ip.split('.').map((part: string) => Number(part));
        if (parts.length === 4 && parts.every((part: number) => Number.isInteger(part) && part >= 0 && part <= 255)) {
            return parts;
        }
        return [255, 255, 255, 255];
    }

    private clusterTemplateBmcSortedRows(rows: any[]): any[] {
        return [...(rows || [])].sort((left: any, right: any) => {
            const leftParts = this.clusterTemplateIpSortParts(left);
            const rightParts = this.clusterTemplateIpSortParts(right);
            for (let index = 0; index < 4; index++) {
                if (leftParts[index] !== rightParts[index]) return leftParts[index] - rightParts[index];
            }
            return Number(left?.index || 0) - Number(right?.index || 0);
        });
    }

    private clusterTemplateApplyGeneratedHostnames(rows: any[]): any[] {
        const result = (rows || []).map((row: any) => ({ ...row }));
        const relayRows = this.clusterTemplateBmcSortedRows(result.filter((row: any) => row.role_type === 'relay'));
        const authorityRows = relayRows.filter((row: any) => this.clusterTemplateRelationType(row) !== 'member');
        const authorityBySubnet: any = {};
        const authorityNumberByKey: any = {};

        relayRows.forEach((row: any, relayIndex: number) => {
            const relayNumber = this.clusterTemplateSequenceNumber(relayIndex);
            const relayLabel = this.clusterTemplateFormatSequence(relayNumber);
            row.relay_sequence_number = relayNumber;
            row.relay_sequence_label = relayLabel;
            if (!String(row.template_hostname || '').trim() || row.template_hostname === '-') {
                row.template_hostname = this.clusterTemplateRelayHostname(relayIndex) || (row.matched_node?.name || '-');
            }
            if (this.clusterTemplateRelationType(row) !== 'member') {
                const subnetKey = this.clusterTemplateSubnetKey(row).toLowerCase();
                if (subnetKey) authorityBySubnet[subnetKey] = row;
                for (const key of this.clusterTemplateAuthorityLookupKeys(row)) authorityNumberByKey[key] = relayLabel;
            }
        });

        const lowerCounters: any = {};
        const lowerRows = this.clusterTemplateBmcSortedRows(result.filter((row: any) => row.role_type === 'compute'));
        lowerRows.forEach((row: any, computeIndex: number) => {
            const subnetKey = this.clusterTemplateSubnetKey(row).toLowerCase();
            let authority = subnetKey ? authorityBySubnet[subnetKey] : null;
            if (!authority && authorityRows.length === 1) authority = authorityRows[0];
            const authorityLabel = authority?.relay_sequence_label || authorityNumberByKey[String(row.member_authority || '').trim().toLowerCase()] || this.clusterTemplateFormatSequence(this.clusterTemplateSequenceNumber(0));
            lowerCounters[authorityLabel] = Number(lowerCounters[authorityLabel] || 0) + 1;
            if (!String(row.template_hostname || '').trim() || row.template_hostname === '-') {
                row.template_hostname = this.clusterTemplateComputeHostname(computeIndex) || (row.matched_node?.name || '-');
            }
            row.parent_relay_sequence_label = authorityLabel;
        });

        return result;
    }

    private clusterTemplateInventoryIndexes(rules: any[]): any {
        const indexes: any = {};
        for (const rule of rules) indexes[rule.key] = {};
        for (const node of this.selectableNodes || []) {
            if (node?.cluster_id) continue;
            for (const rule of rules) {
                const value = this.inventoryIdentityValue(node, rule.key);
                if (!value) continue;
                if (!indexes[rule.key][value]) indexes[rule.key][value] = [];
                indexes[rule.key][value].push(node);
            }
        }
        return indexes;
    }

    public clusterTemplateMappingRows(): any[] {
        const templateNodes = this.clusterTemplateValidation?.nodes || [];
        const rules = (this.clusterTemplateMappingRules || []).filter((rule: any) => rule?.key);
        const indexes = this.clusterTemplateInventoryIndexes(rules);
        const usedNodeIds = new Set<string>();
        const mappedRows = templateNodes.map((node: any, index: number) => {
            let matchedNode: any = null;
            let matchedRule: any = null;
            let conflicted = false;

            for (let ruleIndex = 0; ruleIndex < rules.length; ruleIndex++) {
                const rule = rules[ruleIndex];
                const value = this.clusterTemplateIdentityValue(node, rule.key);
                if (!value) continue;
                const candidates = (indexes[rule.key] && indexes[rule.key][value]) || [];
                const available = candidates.filter((item: any) => !usedNodeIds.has(String(item?.id || '')));
                if (available.length === 1) {
                    matchedNode = available[0];
                    matchedRule = { ...rule, priority: ruleIndex + 1 };
                    usedNodeIds.add(String(matchedNode?.id || ''));
                    break;
                }
                if (available.length > 1) {
                    matchedRule = { ...rule, priority: ruleIndex + 1 };
                    conflicted = true;
                    break;
                }
            }

            const roleType = this.clusterTemplateRoleType(node);
            const autoCreate = !matchedNode && !conflicted;
            const status = matchedNode ? 'matched' : autoCreate ? 'auto' : 'failed';
            const matchedBy = matchedRule ? `${matchedRule.priority}순위 (${matchedRule.shortLabel || matchedRule.label})` : '-';
            const rack = String(node?.rack || '').trim();
            const unit = String(node?.unit || '').trim();

            return {
                ...node,
                index: node?.index || index + 1,
                role_type: roleType,
                template_hostname: String(node?.template_hostname || '').trim(),
                matched_node: matchedNode,
                registered_hostname: matchedNode?.name || '-',
                kiera_bmc_mac: matchedNode?.bmc_mac || '-',
                kiera_bmc_ip: matchedNode?.bmc_ip || '-',
                matched_by: matchedNode ? matchedBy : '-',
                mapping_status: status,
                rack: rack || '-',
                unit: unit || '-',
                note: matchedNode ? '-' : conflicted ? '중복 후보' : autoCreate ? 'DB 등록 예정' : '등록 노드 없음',
            };
        });
        return this.clusterTemplateApplyGeneratedHostnames(mappedRows);
    }

    public clusterTemplateRelayMappingRows(): any[] {
        return this.clusterTemplateMappingRows().filter((row: any) => row.role_type === 'relay');
    }

    public clusterTemplateComputePreMappingRows(): any[] {
        return this.clusterTemplateMappingRows().filter((row: any) => row.role_type === 'compute' && row.mapping_status !== 'auto');
    }

    public clusterTemplateComputeAutoMappingRows(): any[] {
        return this.clusterTemplateMappingRows().filter((row: any) => row.role_type === 'compute' && row.mapping_status === 'auto');
    }

    public clusterTemplateMappingDisplayRows(section: string, rows: any[]): any[] {
        if (this.clusterTemplateMappingExpanded[section]) return rows || [];
        return (rows || []).slice(0, 3);
    }

    public toggleClusterTemplateMappingSection(section: string) {
        this.clusterTemplateMappingExpanded[section] = !this.clusterTemplateMappingExpanded[section];
        this.service.render();
    }

    public clusterTemplateMappingSectionActionLabel(section: string, total: number): string {
        return this.clusterTemplateMappingExpanded[section] ? '접기' : `전체 ${total.toLocaleString()}개 보기`;
    }

    public clusterTemplateMappingStats(): any {
        const rows = this.clusterTemplateMappingRows();
        const total = rows.length;
        const matched = rows.filter((row: any) => row.mapping_status === 'matched').length;
        const failed = rows.filter((row: any) => row.mapping_status === 'failed').length;
        const auto = rows.filter((row: any) => row.mapping_status === 'auto').length;
        return { total, matched, failed, auto };
    }

    public clusterTemplateMappingRate(value: number, total: number): string {
        if (!total) return '0%';
        const rate = (Number(value || 0) / Number(total || 1)) * 100;
        const text = Math.abs(rate - Math.round(rate)) < 0.05 ? rate.toFixed(0) : rate.toFixed(1);
        return `${text}%`;
    }

    public clusterTemplateMappingCountLabel(value: number, total: number): string {
        return `${Number(value || 0).toLocaleString()} (${this.clusterTemplateMappingRate(value, total)})`;
    }

    public clusterTemplateMappingStatusCount(rows: any[], status: string): number {
        return (rows || []).filter((row: any) => row.mapping_status === status).length;
    }

    public clusterTemplateMappingNumber(value: any): string {
        return Number(value || 0).toLocaleString();
    }

    public clusterTemplateMappingSideSections(): any[] {
        const relayRows = this.clusterTemplateRelayMappingRows();
        const computePreRows = this.clusterTemplateComputePreMappingRows();
        const computeAutoRows = this.clusterTemplateComputeAutoMappingRows();
        return [
            {
                title: 'Relay 노드 (Pre-Commissioning)',
                total: relayRows.length,
                rows: [
                    { icon: 'bx-check-circle', tone: 'text-emerald-600', label: '매칭 완료', value: relayRows.filter((row: any) => row.mapping_status === 'matched').length },
                    { icon: 'bx-radio-circle-marked', tone: 'text-indigo-600', label: 'DB 등록 예정', value: relayRows.filter((row: any) => row.mapping_status === 'auto').length },
                    { icon: 'bx-x-circle', tone: 'text-red-500', label: '매칭 실패', value: relayRows.filter((row: any) => row.mapping_status === 'failed').length },
                    { icon: 'bx-minus-circle', tone: 'text-slate-500', label: '미매칭', value: 0 },
                ],
            },
            {
                title: 'Compute 노드 (Pre-Commissioning)',
                total: computePreRows.length,
                rows: [
                    { icon: 'bx-check-circle', tone: 'text-emerald-600', label: '매칭 완료', value: computePreRows.filter((row: any) => row.mapping_status === 'matched').length },
                    { icon: 'bx-x-circle', tone: 'text-red-500', label: '매칭 실패', value: computePreRows.filter((row: any) => row.mapping_status === 'failed').length },
                    { icon: 'bx-minus-circle', tone: 'text-slate-500', label: '미매칭', value: 0 },
                ],
            },
            {
                title: 'Compute 노드 (Auto Commissioning)',
                total: computeAutoRows.length,
                rows: [
                    { icon: 'bx-radio-circle-marked', tone: 'text-indigo-600', label: '자동 시운전 예정', value: computeAutoRows.length },
                ],
            },
        ];
    }

    public clusterTemplateRackUnitSummaryRows(): any[] {
        const rows = this.clusterTemplateMappingRows();
        const rackSet = new Set<string>();
        let maxUnit = Number(this.clusterTemplateDraft?.rack_unit || 0);
        for (const row of rows) {
            const rack = String(row?.rack || '').trim();
            if (rack && rack !== '-') rackSet.add(rack);
            const unit = Number(String(row?.unit || '').replace(/[^0-9]/g, ''));
            if (unit > maxUnit) maxUnit = unit;
        }
        return [
            { label: 'Rack 수', value: rackSet.size || '-' },
            { label: 'Unit 수 (최대/랙)', value: maxUnit || '-' },
            { label: '총 노드 수', value: rows.length.toLocaleString() },
        ];
    }

    private clusterTemplateValueList(rows: any[], keys: string[]): string[] {
        const values: string[] = [];
        const seen = new Set<string>();
        for (const row of rows || []) {
            for (const key of keys) {
                const value = String(row?.[key] ?? '').trim();
                if (!value || value === '-') continue;
                const normalized = value.toLowerCase();
                if (seen.has(normalized)) continue;
                seen.add(normalized);
                values.push(value);
            }
        }
        return values;
    }

    private clusterTemplateListLabel(values: string[], empty: string = '-'): string {
        if (!values || values.length === 0) return empty;
        if (values.length === 1) return values[0];
        return `${values[0]} 외 ${values.length - 1}개`;
    }

    private clusterTemplateFirstValue(rows: any[], keys: string[], fallback: string = '-'): string {
        const values = this.clusterTemplateValueList(rows, keys);
        return values.length > 0 ? values[0] : fallback;
    }

    private clusterTemplateNetworkLabel(rows: any[]): string {
        const vlanValues = this.clusterTemplateValueList(rows, ['vlan_id', 'vlan']);
        const subnetValues = this.clusterTemplateValueList(rows, ['dhcp_group_key', 'subnet_name', 'subnet', 'subnet_cidr']);
        if (vlanValues.length > 0 && subnetValues.length > 0) {
            return `${this.clusterTemplateListLabel(vlanValues.map((value: string) => `VLAN ${value}`))} (${this.clusterTemplateListLabel(subnetValues)})`;
        }
        if (vlanValues.length > 0) return this.clusterTemplateListLabel(vlanValues.map((value: string) => `VLAN ${value}`));
        return this.clusterTemplateListLabel(subnetValues);
    }

    private clusterTemplateRackCount(): number {
        const rows = this.clusterTemplateMappingRows();
        const rackSet = new Set<string>();
        for (const row of rows) {
            const rack = String(row?.rack || '').trim();
            if (rack && rack !== '-') rackSet.add(rack);
        }
        if (rackSet.size > 0) return rackSet.size;
        const rackUnit = Number(this.clusterTemplateDraft?.rack_unit || 1);
        return Math.max(1, Math.ceil(rows.length / Math.max(1, rackUnit)));
    }

    private clusterTemplateStep5Stats(): any {
        const rows = this.clusterTemplateMappingRows();
        const relayRows = rows.filter((row: any) => row.role_type === 'relay');
        const computePreRows = rows.filter((row: any) => row.role_type === 'compute' && row.mapping_status !== 'auto');
        const computeAutoRows = rows.filter((row: any) => row.role_type === 'compute' && row.mapping_status === 'auto');
        const matchedRows = rows.filter((row: any) => row.mapping_status === 'matched');
        const failedRows = rows.filter((row: any) => row.mapping_status === 'failed');
        const autoRows = rows.filter((row: any) => row.mapping_status === 'auto');
        return {
            rows,
            relayRows,
            computePreRows,
            computeAutoRows,
            matchedRows,
            failedRows,
            autoRows,
            total: rows.length,
            relay: relayRows.length,
            computePre: computePreRows.length,
            computeAuto: computeAutoRows.length,
            matched: matchedRows.length,
            failed: failedRows.length,
            auto: autoRows.length,
            rackCount: this.clusterTemplateRackCount(),
        };
    }

    public clusterTemplateStep5BadgeClass(tone: string): string {
        if (tone === 'success') return 'bg-green-100 text-green-700';
        if (tone === 'warning') return 'bg-amber-100 text-amber-700';
        if (tone === 'info') return 'bg-indigo-100 text-indigo-700';
        return 'bg-zinc-100 text-zinc-700';
    }

    public clusterTemplateStep5ClusterInfoRows(): any[] {
        const rows = [
            { label: '클러스터 이름', value: this.clusterTemplateDraft?.name || '-' },
            { label: '생성 그룹', value: this.clusterTemplateDraft?.name || '-', sub: 'Cluster Name 기준으로 자동 생성됩니다.' },
            { label: '설명', value: this.clusterTemplateDraft?.description || '-' },
            ...(this.isClusterTemplateRelayMode() ? [{ label: 'Relay Node Prefix', value: this.clusterTemplateDraft?.relay_prefix || '-' }] : []),
            { label: this.isClusterTemplateRelayMode() ? 'Compute Node Prefix' : 'Node Prefix', value: this.clusterTemplateComputePrefix() || '-' },
            { label: 'Prefix Number Padding', value: this.clusterTemplatePaddingLabel() },
            { label: 'Starting Number', value: this.clusterTemplateDraft?.starting_number || '-' },
            { label: '상태', value: '생성 후 Active', badge: 'success', sub: '생성 직후 Active 상태로 설정됩니다.' },
        ];
        return rows;
    }

    public clusterTemplateStep5NetworkRows(): any[] {
        const rows = this.clusterTemplateMappingRows();
        const cluster = this.clusterTemplateValidation?.cluster || {};
        const dhcpStart = this.clusterTemplateFirstValue(rows, ['dhcp_start'], '');
        const dhcpEnd = this.clusterTemplateFirstValue(rows, ['dhcp_end'], '');
        return [
            { label: '관리 네트워크 (VLAN)', value: this.clusterTemplateNetworkLabel(rows) },
            { label: '프로비저닝 네트워크 (VLAN)', value: this.clusterTemplateNetworkLabel(rows) },
            { label: 'PXE Boot 서버', value: cluster.pxe_boot_server || this.clusterTemplateFirstValue(this.clusterTemplateRelayMappingRows(), ['template_provisioning_ip', 'template_bmc_ip']) },
            { label: 'DHCP 범위', value: dhcpStart && dhcpEnd ? `${dhcpStart} - ${dhcpEnd}` : '-' },
            { label: 'DNS 서버', value: cluster.dns_server || this.clusterTemplateFirstValue(rows, ['dns_server'], '-') },
            { label: 'NTP 서버', value: cluster.ntp_server || this.clusterTemplateFirstValue(rows, ['ntp_server'], '-') },
        ];
    }

    private clusterTemplateStep5SummaryRow(label: string, rows: any[], autoLabel: string = '0'): any {
        const total = rows.length;
        const matched = rows.filter((row: any) => row.mapping_status === 'matched').length;
        const failed = rows.filter((row: any) => row.mapping_status === 'failed').length;
        const auto = rows.filter((row: any) => row.mapping_status === 'auto').length;
        const successBase = total - failed;
        const rate = total ? `${this.clusterTemplateMappingRate(successBase, total)}${auto > 0 ? ' (예정)' : ''}` : '-';
        return {
            label,
            total: this.clusterTemplateMappingNumber(total),
            matched: matched > 0 ? this.clusterTemplateMappingNumber(matched) : '-',
            failed: failed > 0 ? this.clusterTemplateMappingNumber(failed) : '0',
            auto: auto > 0 ? this.clusterTemplateMappingNumber(auto) : autoLabel,
            rate,
            failedCount: failed,
        };
    }

    public clusterTemplateStep5NodeSummaryRows(): any[] {
        const stats = this.clusterTemplateStep5Stats();
        return [
            this.clusterTemplateStep5SummaryRow('Relay 노드 (Pre-Commissioning)', stats.relayRows),
            this.clusterTemplateStep5SummaryRow('Compute 노드 (Pre-Commissioning)', stats.computePreRows),
            this.clusterTemplateStep5SummaryRow('Compute 노드 (Auto Commissioning)', stats.computeAutoRows, this.clusterTemplateMappingNumber(stats.computeAutoRows.length)),
        ];
    }

    public clusterTemplateStep5ResourceRows(): any[] {
        const stats = this.clusterTemplateStep5Stats();
        const networkCount = Math.max(1, this.clusterTemplateValueList(stats.rows, ['subnet', 'subnet_cidr', 'vlan_id']).length);
        return [
            { icon: 'bx-network-chart', label: '클러스터', value: '1' },
            { icon: 'bx-server', label: '노드', value: this.clusterTemplateMappingNumber(stats.total) },
            { icon: 'bx-cube', label: 'Chassis', value: this.clusterTemplateMappingNumber(this.clusterTemplateChassisCount(stats.rows)) },
            { icon: 'bx-table', label: '랙', value: this.clusterTemplateMappingNumber(stats.rackCount) },
            { icon: 'bx-git-branch', label: '서브넷', value: this.clusterTemplateMappingNumber(networkCount) },
            { icon: 'bx-globe', label: 'DHCP', value: '1' },
            { icon: 'bx-cube', label: '릴레이 그룹', value: stats.relay > 0 ? '1' : '0' },
            { icon: 'bx-code-alt', label: '스크립트', value: this.clusterTemplateValidation?.cluster?.script ? '1' : '0' },
            { icon: 'bx-image', label: '이미지', value: this.clusterTemplateValidation?.cluster?.image ? '1' : '0' },
            { icon: 'bx-hdd', label: '스토리지', value: this.clusterTemplateValidation?.cluster?.storage ? '1' : '0' },
        ];
    }

    public clusterTemplateStep5PostTasks(): any[] {
        return [
            { label: 'Cluster 생성' },
            { label: 'Group 생성' },
            { label: 'Node 생성' },
            { label: 'Chassis 생성/재사용 및 Node-Slot 매핑' },
            { label: 'Rack 정보 저장' },
            { label: 'VLAN 저장' },
            { label: 'Relay Group 생성(Optional)' },
            { label: 'Provisioning Network 생성' },
            { label: 'Node Inventory 저장' },
            { label: 'Cluster Summary 생성' },
        ];
    }

    private clusterTemplateChassisCount(rows?: any[]): number {
        const names = new Set<string>();
        for (const row of rows || this.clusterTemplateMappingRows()) {
            const name = String(row?.chassis_name || '').trim().toLowerCase();
            if (name) names.add(name);
        }
        return names.size;
    }

    public clusterTemplateStep5SummaryCards(): any[] {
        const stats = this.clusterTemplateStep5Stats();
        return [
            { label: '총 노드 수', value: this.clusterTemplateMappingNumber(stats.total), tone: 'indigo', icon: 'bx-server' },
            { label: 'Relay 노드 (Pre-Commissioning)', value: this.clusterTemplateMappingNumber(stats.relay), tone: 'green', icon: 'bx-cube' },
            { label: 'Compute 노드 (Pre-Commissioning)', value: this.clusterTemplateMappingNumber(stats.computePre), tone: 'blue', icon: 'bx-package' },
            { label: 'Compute 노드 (Auto Commissioning)', value: this.clusterTemplateMappingNumber(stats.computeAuto), tone: 'amber', icon: 'bx-package' },
        ];
    }

    public clusterTemplateStep5SummaryCardClass(tone: string): string {
        if (tone === 'green') return 'border-green-200 bg-green-50 text-green-700';
        if (tone === 'blue') return 'border-blue-200 bg-blue-50 text-blue-700';
        if (tone === 'amber') return 'border-amber-200 bg-amber-50 text-amber-700';
        return 'border-indigo-200 bg-indigo-50 text-indigo-700';
    }

    public clusterTemplateStep5RackRows(): any[] {
        const stats = this.clusterTemplateStep5Stats();
        const rackUnit = Math.max(1, Number(this.clusterTemplateDraft?.rack_unit || 1));
        const capacity = stats.rackCount * rackUnit;
        const usage = capacity ? `${this.clusterTemplateMappingNumber(stats.total)} (${this.clusterTemplateMappingRate(stats.total, capacity)})` : '-';
        return [
            { label: 'Rack 수', value: this.clusterTemplateMappingNumber(stats.rackCount) },
            { label: 'Rack Unit 수 (최대/랙)', value: this.clusterTemplateMappingNumber(rackUnit) },
            { label: '총 Rack Unit 수', value: this.clusterTemplateMappingNumber(capacity) },
            { label: '사용 예정 Rack Unit 수', value: usage },
        ];
    }

    public clusterTemplateStep5OtherRows(): any[] {
        const cluster = this.clusterTemplateValidation?.cluster || {};
        return [
            { label: 'SSH CA', value: cluster.ssh_ca || '사용 안함' },
            { label: '스크립트', value: cluster.script ? '1개 연결' : '연결 안함' },
            { label: '이미지', value: cluster.image ? '1개 연결' : '연결 안함' },
            { label: '릴레이 그룹', value: this.clusterTemplateStep5Stats().relay > 0 ? '1개' : '없음' },
            { label: '스토리지', value: cluster.storage ? '1개' : '연결 안함' },
            { label: '모니터링 (Zabbix)', value: cluster.zabbix ? '연결' : '연결 안함' },
        ];
    }

    public clusterTemplateStep5CreateDisabledReason(): string {
        if (this.creating) return '';
        const draft = this.clusterTemplateDraft || {};
        if (!String(draft.name || '').trim()) return 'Cluster Name을 입력하세요.';
        if (!this.clusterTemplateMappingRows().length) return '템플릿 노드 매핑 결과가 없습니다.';
        const stats = this.clusterTemplateStep5Stats();
        if (stats.failed > 0) return '매핑 실패 노드를 해결한 후 클러스터를 생성할 수 있습니다.';
        if (this.isClusterTemplateRelayMode() && stats.relay === 0) return 'Relay Provisioning 모드에서는 Relay 노드 매칭이 필요합니다.';
        if (stats.matched === 0 && stats.auto === 0) return '생성할 노드가 없습니다.';
        return '';
    }

    public clusterTemplateStep5CanCreate(): boolean {
        return !this.clusterTemplateStep5CreateDisabledReason();
    }

    public clusterTemplateMappingStatusClass(status: string): string {
        if (status === 'matched') return 'text-emerald-700';
        if (status === 'failed') return 'text-red-600';
        if (status === 'auto') return 'text-indigo-700';
        return 'text-zinc-600';
    }

    public clusterTemplateMappingStatusIcon(status: string): string {
        if (status === 'matched') return 'bx-check-circle';
        if (status === 'failed') return 'bx-x-circle';
        if (status === 'auto') return 'bx-radio-circle-marked';
        return 'bx-minus-circle';
    }

    public clusterTemplateMappingStatusLabel(status: string): string {
        if (status === 'matched') return '매칭 완료';
        if (status === 'failed') return '매칭 실패';
        if (status === 'auto') return '자동 등록 예정';
        return '미매칭';
    }

    public downloadClusterTemplateMappingResult() {
        const headers = [
            'template_hostname',
            'role',
            'template_bmc_mac',
            'template_bmc_ip',
            'registered_hostname',
            'kiera_bmc_mac',
            'kiera_bmc_ip',
            'mapping_status',
            'matched_by',
            'rack',
            'unit',
            'note',
        ];
        const escapeCsv = (value: any) => `"${String(value ?? '').replace(/"/g, '""')}"`;
        const rows = this.clusterTemplateMappingRows().map((row: any) => [
            row.template_hostname,
            row.role || row.role_type,
            row.template_bmc_mac,
            row.template_bmc_ip,
            row.registered_hostname,
            row.kiera_bmc_mac,
            row.kiera_bmc_ip,
            this.clusterTemplateMappingStatusLabel(row.mapping_status),
            row.matched_by,
            row.rack,
            row.unit,
            row.note,
        ]);
        const csv = [headers, ...rows].map((row: any[]) => row.map(escapeCsv).join(',')).join('\n');
        const blob = new Blob(['\uFEFF' + csv], { type: 'text/csv;charset=utf-8;' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = 'cluster-template-node-mapping.csv';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }

    public async downloadClusterTemplateSample(mode: string = 'relay') {
        const sampleMode = String(mode || '').trim().toLowerCase() === 'direct' ? 'direct' : 'relay';
        this.modalError = '';
        const { code, data } = await wiz.call("template_sample", { mode: sampleMode });
        if (code !== 200 || !data?.content_base64) {
            this.modalError = data?.message || '템플릿 샘플을 생성하지 못했습니다.';
            await this.service.render();
            return;
        }
        this.downloadBase64File(
            data.content_base64,
            data.filename || (sampleMode === 'direct' ? 'cluster-template-direct-sample.xlsx' : 'cluster-template-relay-sample.xlsx'),
            data.mime_type || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        );
    }

    public async nextClusterTemplateStep() {
        this.modalError = '';
        if (this.wizardStep === 1 && !this.clusterTemplateSelectedFileName) {
            this.modalError = '템플릿 파일을 선택하세요.';
            return;
        }
        if (this.wizardStep === 1) {
            const valid = await this.validateClusterTemplate();
            if (!valid) return;
            this.wizardStep = 2;
            await this.service.render();
            return;
        }
        if (this.wizardStep === 3 && !this.validateClusterTemplateInfo()) {
            await this.service.render();
            return;
        }
        if (this.wizardStep >= 1 && this.wizardStep < 5) {
            this.wizardStep += 1;
            return;
        }
        this.modalError = '템플릿 생성 제출 API는 별도 연결이 필요합니다.';
    }

    private clusterTemplateMatchedNode(row: any): any {
        return row?.matched_node || null;
    }

    private clusterTemplateNodeName(row: any, index: number): string {
        const explicit = String(row?.template_hostname || '').trim();
        if (explicit && explicit !== '-') return explicit;
        const generated = this.clusterTemplateHostname(row, index);
        if (generated && generated !== '-') return generated;
        return String(row?.matched_node?.name || row?.matched_node?.original_name || '').trim() || '-';
    }

    private clusterTemplateCreateNodeConfig(row: any, index: number): any {
        const node = this.clusterTemplateMatchedNode(row);
        if (!node?.id) return null;
        return {
            id: node.id,
            name: this.clusterTemplateNodeName(row, index),
        };
    }

    private clusterTemplateRegistrationFields(row: any): any {
        const result: any = {};
        for (const slot of ['ethernet1', 'ethernet2', 'ethernet3', 'ethernet4', 'ib1', 'ib2']) {
            for (const field of ['name', 'ip', 'mac']) result[slot + '_' + field] = row?.[slot + '_' + field] || '';
        }
        result.rack_size = row?.rack_size || '';
        result.group_id = row?.group_id || '';
        return result;
    }

    private clusterTemplateAutoNodePayload(row: any, index: number): any {
        const rack = String(row?.rack || '').trim();
        const unit = String(row?.unit || '').trim();
        return {
            template_index: Number(row?.index || index + 1),
            ...this.clusterTemplateRegistrationFields(row),
            template_node_id: row?.template_node_id || '',
            template_hostname: row?.template_hostname || '',
            name: this.clusterTemplateNodeName(row, index),
            role: String(row?.role || '').trim(),
            role_type: this.clusterTemplateRoleType(row),
            relation_type: this.clusterTemplateRelationType(row),
            member_authority: row?.member_authority || '',
            relay_hostname: row?.relay_hostname || '',
            group_name: row?.group_name || '',
            bmc_credential_name: row?.bmc_credential_name || '',
            boot_type: row?.boot_type || '',
            dhcp_group_key: this.clusterTemplateSubnetKey(row),
            provider_interface: row?.provider_interface || '',
            mac_address: row?.template_provisioning_mac || '',
            ip_address: row?.template_provisioning_ip || '',
            bmc_type: row?.provider_interface || (row?.template_bmc_ip ? 'IPMI' : 'NONE'),
            bmc_ip: row?.template_bmc_ip || '',
            bmc_mac: row?.template_bmc_mac || '',
            subnet: row?.subnet || '',
            netmask: row?.netmask || '',
            gateway: row?.gateway || '',
            node_provisioning_ip: row?.node_provisioning_ip || '',
            node_provisioning_netmask: row?.node_provisioning_netmask || '',
            node_provisioning_gateway: row?.node_provisioning_gateway || '',
            node_provisioning_devname: row?.node_provisioning_devname || '',
            vlan_id: row?.vlan_id || '',
            rack: rack === '-' ? '' : rack,
            unit: unit === '-' ? '' : unit,
            rack_size: Number(row?.rack_size || 1),
            chassis_name: row?.chassis_name || '',
            chassis_model: row?.chassis_model || '',
            chassis_slot: row?.chassis_slot || '',
            infiniband_gateway: row?.infiniband_gateway || '',
            infiniband_ifname: row?.infiniband_ifname || '',
            infiniband_ip: row?.infiniband_ip || '',
            infiniband_netmask: row?.infiniband_netmask || '',
            infiniband_subnet: row?.infiniband_subnet || '',
            comment: row?.comment || '',
            status: 'ready',
            deploy_status: 'none',
            notes: String(row?.comment || `Created from cluster template ${this.clusterTemplateSelectedFileName || ''}`).trim(),
        };
    }

    private clusterTemplateRoleDescriptor(row: any, index: number): any {
        return {
            template_index: Number(row?.index || index + 1),
            node_id: row?.matched_node?.id || '',
            ...this.clusterTemplateRegistrationFields(row),
            template_node_id: row?.template_node_id || '',
            template_hostname: row?.template_hostname || '',
            name: this.clusterTemplateNodeName(row, index),
            role: String(row?.role || '').trim(),
            role_type: this.clusterTemplateRoleType(row),
            relation_type: this.clusterTemplateRelationType(row),
            member_authority: row?.member_authority || '',
            relay_hostname: row?.relay_hostname || '',
            group_name: row?.group_name || '',
            bmc_credential_name: row?.bmc_credential_name || '',
            boot_type: row?.boot_type || '',
            dhcp_group_key: this.clusterTemplateSubnetKey(row),
            subnet: row?.subnet || '',
            netmask: row?.netmask || '',
            gateway: row?.gateway || '',
            vlan_id: row?.vlan_id || '',
            dhcp_start: row?.dhcp_start || '',
            dhcp_end: row?.dhcp_end || '',
            template_bmc_ip: row?.template_bmc_ip || '',
            template_provisioning_ip: row?.template_provisioning_ip || '',
            template_provisioning_mac: row?.template_provisioning_mac || '',
            rack: row?.rack || '',
            unit: row?.unit || '',
            chassis_name: row?.chassis_name || '',
            chassis_model: row?.chassis_model || '',
            chassis_slot: row?.chassis_slot || '',
        };
    }

    private clusterTemplateRelationType(row: any): string {
        const explicit = String(row?.relation_type || '').trim().toLowerCase();
        if (explicit.includes('member') || explicit.includes('멤버')) return 'member';
        if (explicit.includes('authority')) return 'authority';
        if (explicit.includes('lower') || explicit.includes('하위')) return 'lower';
        const role = String(row?.role || '').trim().toLowerCase();
        if (role.includes('member') || role.includes('멤버')) return 'member';
        if (this.clusterTemplateRoleType(row) === 'relay') return 'authority';
        return 'lower';
    }

    private clusterTemplateSubnetKey(row: any): string {
        const raw = String(row?.dhcp_group_key || row?.subnet_name || row?.subnet || '').trim();
        if (!raw) return '';
        const normalized = raw.toLowerCase();
        const match = (this.relaySubnets || []).find((subnet: any) => {
            const candidates = [
                subnet?.key,
                subnet?.name,
                subnet?.label,
                subnet?.cidr,
                subnet?.id ? `id:${subnet.id}` : '',
                subnet?.id,
                subnet?.cidr ? `cidr:${subnet.cidr}` : '',
                subnet?.vlan_id && String(subnet.vlan_id) !== '0' ? `vlan:${subnet.vlan_id}` : '',
            ];
            return candidates.some((value: any) => String(value || '').trim().toLowerCase() === normalized);
        });
        return String(match?.key || raw).trim();
    }

    private clusterTemplateAuthorityLookupKeys(row: any): string[] {
        const values = [
            row?.template_node_id,
            row?.template_hostname,
            row?.template_bmc_ip,
            row?.template_provisioning_ip,
            row?.matched_node?.id,
            row?.matched_node?.name,
            row?.matched_node?.bmc_ip,
            row?.matched_node?.ip_address,
        ];
        const keys: string[] = [];
        for (const value of values) {
            const text = String(value || '').trim().toLowerCase();
            if (text && !keys.includes(text)) keys.push(text);
        }
        return keys;
    }

    private buildClusterTemplateRelayConfig(rows: any[]): any {
        const relayRows = (rows || []).filter((row: any) => this.clusterTemplateRoleType(row) === 'relay' && row.mapping_status === 'matched' && row.matched_node?.id);
        if (relayRows.length === 0) return {};
        const authorityRows = relayRows.filter((row: any) => this.clusterTemplateRelationType(row) !== 'member');
        const relayMemberRows = relayRows.filter((row: any) => this.clusterTemplateRelationType(row) === 'member');
        if (authorityRows.length === 0) return {};
        const computeRows = (rows || []).filter((row: any) => this.clusterTemplateRoleType(row) === 'compute' && row.mapping_status === 'matched' && row.matched_node?.id);
        const authorityLookup: any = {};
        for (const row of authorityRows) {
            for (const key of this.clusterTemplateAuthorityLookupKeys(row)) authorityLookup[key] = row;
        }
        const authorityForMember = (row: any): any => {
            const ref = String(row?.member_authority || row?.authority || '').trim().toLowerCase();
            if (ref && authorityLookup[ref]) return authorityLookup[ref];
            return authorityRows.length === 1 ? authorityRows[0] : null;
        };
        const authorityForLower = (row: any): any => {
            const ref = String(row?.member_authority || row?.authority || '').trim().toLowerCase();
            if (ref && authorityLookup[ref]) return authorityLookup[ref];
            return authorityRows.length === 1 ? authorityRows[0] : null;
        };
        const memberRows = relayMemberRows;
        const lowerRows = computeRows.filter((row: any) => this.clusterTemplateRelationType(row) !== 'member');
        const lowerAssignments = lowerRows
            .map((row: any) => {
                const authority = authorityForLower(row);
                if (!authority?.matched_node?.id) return null;
                return {
                    node_id: row.matched_node.id,
                    authority_node_id: authority.matched_node.id,
                    dhcp_group_key: this.clusterTemplateSubnetKey(authority),
                };
            })
            .filter((row: any) => !!row);
        return {
            authorities: authorityRows.map((row: any) => ({
                node_id: row.matched_node.id,
                dhcp_group_key: this.clusterTemplateSubnetKey(row),
            })),
            member_node_ids: memberRows.map((row: any) => row.matched_node.id),
            member_assignments: memberRows.map((row: any) => {
                const authority = authorityForMember(row);
                return {
                    node_id: row.matched_node.id,
                    authority_node_id: authority?.matched_node?.id || '',
                    dhcp_group_key: authority ? this.clusterTemplateSubnetKey(authority) : '',
                };
            }),
            lower_node_ids: lowerRows.map((row: any) => row.matched_node.id),
            lower_assignments: lowerAssignments,
        };
    }

    private clusterTemplateUnassignedComputeRows(rows: any[]): any[] {
        const usableRows = (rows || []).filter((row: any) => row.mapping_status !== 'failed');
        const authorityRows = usableRows.filter((row: any) =>
            this.clusterTemplateRoleType(row) === 'relay'
            && this.clusterTemplateRelationType(row) !== 'member'
        );
        if (authorityRows.length <= 1) return [];

        const authorityLookup = new Set<string>();
        for (const authority of authorityRows) {
            for (const key of this.clusterTemplateAuthorityLookupKeys(authority)) authorityLookup.add(key);
        }
        return usableRows.filter((row: any) => {
            if (this.clusterTemplateRoleType(row) !== 'compute') return false;
            if (this.clusterTemplateRelationType(row) === 'member') return false;
            const reference = String(row?.member_authority || row?.authority || '').trim().toLowerCase();
            return !reference || !authorityLookup.has(reference);
        });
    }

    private unassignedComputeSaveMessage(rows: any[], templateMode: boolean = false): string {
        const labels = (rows || []).slice(0, 5).map((row: any, index: number) => {
            if (templateMode) {
                return row?.template_hostname || row?.matched_node?.name || `템플릿 Compute #${index + 1}`;
            }
            return row?.original_name || row?.name || `#${row?.id || index + 1}`;
        }).join(', ');
        const extra = rows.length > 5 ? ` 외 ${rows.length - 5}개` : '';
        return `Authority가 지정되지 않은 Compute ${rows.length}개(${labels}${extra})가 있습니다. `
            + '해당 노드는 클러스터에는 저장되지만 릴레이 배포 대상에서는 제외됩니다. 그래도 저장하시겠습니까?';
    }

    private clusterTemplatePreviewSnapshot(rows: any[], stats: any): any {
        const validation = this.clusterTemplateValidation || {};
        const file = validation.file || {};
        const cluster = validation.cluster || {};
        const summary = validation.summary || {};
        return {
            file: {
                name: file.name || this.clusterTemplateSelectedFileName || '',
                size: file.size || this.clusterTemplateFileSize || 0,
                uploaded: file.uploaded || this.clusterTemplateUploadedAt || '',
                sheet_name: file.sheet_name || '',
            },
            cluster: {
                name: cluster.name || this.clusterTemplateDraft?.name || '',
                description: cluster.description || this.clusterTemplateDraft?.description || '',
                provisioning_mode: cluster.provisioning_mode || this.clusterTemplateProvisioningModeLabel(),
                relay_prefix: cluster.relay_prefix || this.clusterTemplateDraft?.relay_prefix || '',
                compute_prefix: cluster.compute_prefix || this.clusterTemplateDraft?.compute_prefix || '',
                nodes_per_rack: cluster.nodes_per_rack || this.clusterTemplateDraft?.rack_unit || '',
                template_version: cluster.template_version || this.clusterTemplateDraft?.template_version || '',
            },
            summary: {
                total_nodes: summary.total_nodes ?? stats.total,
                relay_count: summary.relay_count ?? stats.relay,
                compute_count: summary.compute_count ?? (Number(stats.computePre || 0) + Number(stats.computeAuto || 0)),
                chassis_count: summary.chassis_count ?? this.clusterTemplateChassisCount(rows),
                chassis_create_count: summary.chassis_create_count ?? 0,
                chassis_reuse_count: summary.chassis_reuse_count ?? 0,
                chassis_mapped_node_count: summary.chassis_mapped_node_count ?? 0,
                warnings: summary.warnings ?? 0,
                errors: summary.errors ?? stats.failed,
                result_status: summary.result_status || (stats.failed > 0 ? 'error' : 'success'),
            },
            metrics: Array.isArray(validation.metrics) ? validation.metrics : [],
            checks: Array.isArray(validation.checks) ? validation.checks.slice(0, 20) : [],
            details: Array.isArray(validation.details) ? validation.details.slice(0, 30) : [],
            nodes: (rows || []).slice(0, 50).map((row: any) => ({
                role_type: row.role_type || this.clusterTemplateRoleType(row),
                template_hostname: row.template_hostname || '',
                template_bmc_ip: row.template_bmc_ip || '',
                template_bmc_mac: row.template_bmc_mac || '',
                template_provisioning_ip: row.template_provisioning_ip || '',
                template_provisioning_mac: row.template_provisioning_mac || '',
                provider_interface: row.provider_interface || '',
                subnet: row.subnet || '',
                netmask: row.netmask || '',
                gateway: row.gateway || '',
                node_provisioning_ip: row.node_provisioning_ip || '',
                node_provisioning_netmask: row.node_provisioning_netmask || '',
                node_provisioning_gateway: row.node_provisioning_gateway || '',
                node_provisioning_devname: row.node_provisioning_devname || '',
                vlan_id: row.vlan_id || '',
                rack: row.rack || '',
                rack_size: row.rack_size || '',
                unit: row.unit || '',
                chassis_name: row.chassis_name || '',
                chassis_model: row.chassis_model || '',
                chassis_slot: row.chassis_slot || '',
                infiniband_gateway: row.infiniband_gateway || '',
                infiniband_ifname: row.infiniband_ifname || '',
                infiniband_ip: row.infiniband_ip || '',
                infiniband_netmask: row.infiniband_netmask || '',
                infiniband_subnet: row.infiniband_subnet || '',
                dhcp_group_key: row.dhcp_group_key || '',
                comment: row.comment || '',
                mapping_status: row.mapping_status || '',
                matched_by: row.matched_by || '',
            })),
        };
    }

    private async buildClusterTemplateCreatePayload(): Promise<any> {
        const rows = this.clusterTemplateMappingRows();
        const matchedRows = rows.filter((row: any) => row.mapping_status === 'matched' && row.matched_node?.id);
        const autoRows = rows.filter((row: any) => row.mapping_status === 'auto');
        const nodeIds = matchedRows.map((row: any) => row.matched_node.id);
        const nodesConfig = matchedRows
            .map((row: any, index: number) => this.clusterTemplateCreateNodeConfig(row, index))
            .filter((row: any) => !!row);
        const relayConfig = this.buildClusterTemplateRelayConfig(rows);
        const requireRelayConfig = this.isClusterTemplateRelayMode() || (relayConfig.authorities || []).length > 0;
        const stats = this.clusterTemplateStep5Stats();
        const bmcCredential = this.selectedBmcCredentialProfile();
        const payload: any = {
            name: String(this.clusterTemplateDraft?.name || '').trim(),
            description: String(this.clusterTemplateDraft?.description || '').trim(),
            prefix: String(this.clusterTemplateDraft?.compute_prefix || this.clusterTemplateDraft?.cluster_prefix || this.clusterTemplateDraft?.prefix || '').trim(),
            rack_unit: Number(this.clusterTemplateDraft?.rack_unit || 1),
            type: 'general',
            scheduler: 'slurm',
            node_ids: nodeIds,
            nodes_config: nodesConfig,
            template_auto_nodes: autoRows.map((row: any, index: number) => this.clusterTemplateAutoNodePayload(row, index)),
            template_node_roles: rows.map((row: any, index: number) => this.clusterTemplateRoleDescriptor(row, index)),
            relay_config: relayConfig,
            relay_config_json: JSON.stringify(relayConfig),
            require_relay_config: requireRelayConfig,
            config: JSON.stringify({
                creation_mode: 'template',
                template_file: this.clusterTemplateSelectedFileName || '',
                template_uploaded: this.clusterTemplateUploadedAt || '',
                provisioning_mode: this.clusterTemplateDraft?.provisioning_mode || '',
                relay_prefix: this.clusterTemplateDraft?.relay_prefix || '',
                compute_prefix: this.clusterTemplateDraft?.compute_prefix || '',
                prefix_number_padding: this.clusterTemplateDraft?.prefix_padding || '',
                starting_number: this.clusterTemplateDraft?.starting_number || '',
                template_version: this.clusterTemplateDraft?.template_version || '',
                bmc_credential_id: bmcCredential?.id ?? '',
                bmc_credential_name: bmcCredential?.name || '',
                mapping_summary: {
                    total: stats.total,
                    relay: stats.relay,
                    compute_pre: stats.computePre,
                    compute_auto: stats.computeAuto,
                    relay_auto: stats.relayRows.filter((row: any) => row.mapping_status === 'auto').length,
                    auto_created: stats.auto,
                    matched: stats.matched,
                    failed: stats.failed,
                    rack_count: stats.rackCount,
                },
                template_preview: this.clusterTemplatePreviewSnapshot(rows, stats),
            }),
        };
        if (this.clusterTemplateSelectedFile) {
            payload.template_file_name = this.clusterTemplateSelectedFileName || this.clusterTemplateSelectedFile.name || 'cluster-template.xlsx';
            payload.template_file_uploaded = this.clusterTemplateUploadedAt || '';
            payload.template_file_content_base64 = await this.readClusterTemplateFileAsBase64(this.clusterTemplateSelectedFile);
        }
        return payload;
    }

    public async createClusterFromTemplate() {
        this.modalError = '';
        if (!this.validateClusterTemplateInfo()) {
            await this.service.render();
            return;
        }
        const reason = this.clusterTemplateStep5CreateDisabledReason();
        if (reason) {
            this.modalError = reason;
            await this.service.render();
            return;
        }
        const templateRows = this.clusterTemplateMappingRows();
        const unassignedComputeRows = this.clusterTemplateUnassignedComputeRows(templateRows);
        if (unassignedComputeRows.length > 0 && !confirm(this.unassignedComputeSaveMessage(unassignedComputeRows, true))) {
            return;
        }
        let payload: any = null;
        try {
            payload = await this.buildClusterTemplateCreatePayload();
        } catch (e) {
            this.modalError = '템플릿 원본 파일을 읽지 못했습니다.';
            await this.service.render();
            return;
        }
        if (unassignedComputeRows.length > 0) {
            payload.relay_config.allow_unassigned_compute = true;
            payload.relay_config.unassigned_compute_node_ids = unassignedComputeRows
                .map((row: any) => row?.matched_node?.id)
                .filter((nodeId: any) => !!nodeId);
            payload.relay_config_json = JSON.stringify(payload.relay_config);
        }
        this.creating = true;
        await this.service.render();
        const { code, data } = await wiz.call("create", { data: JSON.stringify(payload) });
        this.creating = false;
        if (code === 200) {
            this.showAddModal = false;
            this.resetWizard();
            await this.load();
        } else {
            this.modalError = data?.message || '템플릿 기반 클러스터 생성에 실패했습니다.';
            await this.service.render();
        }
    }

    private emptyNodeFilter() {
        return {
            include: { group: {}, rack: {}, zone: {}, node: {} },
            exclude: { group: {}, rack: {}, zone: {}, node: {} },
        };
    }

    private async loadWizardSources() {
        this.loadingWizard = true;
        this.modalError = '';
        this.groups = [];
        this.zones = [];
        this.selectableNodes = [];
        this.relaySubnets = [];
        try {
            const [, groupResult, zoneResult, nodeResult, subnetResult] = await Promise.all([
                this.loadBmcCredentialProfiles(),
                wiz.call("groups"),
                wiz.call("zones"),
                wiz.call("selectable_nodes"),
                wiz.call("relay_subnets"),
            ]);
            this.groups = groupResult.code === 200 && Array.isArray(groupResult.data?.rows)
                ? groupResult.data.rows
                : [];
            this.selectableNodes = nodeResult.code === 200 && Array.isArray(nodeResult.data?.rows)
                ? nodeResult.data.rows
                : [];
            this.zones = zoneResult.code === 200 && Array.isArray(zoneResult.data?.rows)
                ? zoneResult.data.rows
                : [];
            this.relaySubnets = subnetResult.code === 200 && Array.isArray(subnetResult.data?.rows)
                ? subnetResult.data.rows
                : [];

            if (groupResult.code !== 200) {
                this.modalError = groupResult.data?.message || 'Failed to load groups';
            } else if (nodeResult.code !== 200) {
                this.modalError = nodeResult.data?.message || 'Failed to load selectable nodes';
            } else if (zoneResult.code !== 200) {
                this.modalError = zoneResult.data?.message || 'Failed to load zones';
            } else if (subnetResult.code !== 200) {
                this.modalError = subnetResult.data?.message || 'Failed to load relay subnets';
            }
        } catch (e) {
            this.modalError = 'Failed to load cluster wizard data';
        } finally {
            this.loadingWizard = false;
            await this.service.render();
        }
    }

    public async goStep2() {
        this.modalError = '';
        const provisioningMode = this.manualProvisioningMode();
        const name = (this.newCluster.name || '').trim();
        const relayPrefix = (this.newCluster.relay_prefix || '').trim();
        const computePrefix = (this.newCluster.compute_prefix || this.newCluster.prefix || '').trim();
        const nodePrefix = (this.newCluster.prefix || '').trim();
        const rackUnit = Number(this.newCluster.rack_unit || 0);
        const selectedBmcCredential = this.selectedBmcCredentialProfile();
        if (!name) {
            this.modalError = 'Enter cluster name';
            return;
        }
        if (!rackUnit || rackUnit < 1) {
            this.modalError = 'Enter nodes per rack';
            return;
        }
        if (this.selectedBmcCredentialId !== '' && !selectedBmcCredential) {
            this.modalError = 'Select a valid BMC Credential';
            return;
        }
        if (provisioningMode === 'direct' && !nodePrefix) {
            this.modalError = 'Enter node prefix';
            return;
        }
        if (provisioningMode === 'relay' && !relayPrefix) {
            this.modalError = 'Enter relay node prefix';
            return;
        }
        if (provisioningMode === 'relay' && !computePrefix) {
            this.modalError = 'Enter compute node prefix';
            return;
        }
        this.newCluster.name = name;
        this.newCluster.provisioning_mode = provisioningMode;
        if (provisioningMode === 'direct') {
            this.newCluster.prefix = nodePrefix;
            this.newCluster.relay_prefix = '';
            this.newCluster.compute_prefix = '';
        } else {
            this.newCluster.relay_prefix = relayPrefix;
            this.newCluster.compute_prefix = computePrefix;
            this.newCluster.prefix = computePrefix;
        }
        this.newCluster.rack_unit = rackUnit;
        this.wizardStep = 2;
        await this.service.render();
    }

    public async buildReviewNodes() {
        this.modalError = '';
        if (!this.hasNodeSelection()) {
            this.modalError = 'Select nodes';
            return;
        }
        this.loadingWizard = true;
        await this.service.render();
        const { code, data } = await wiz.call("node_search", {
            filters: JSON.stringify(this.nodeFilter),
            prefix: '',
            offset: 0,
        });
        this.loadingWizard = false;
        if (code !== 200) {
            this.modalError = data?.message || 'Failed to load selected nodes';
            await this.service.render();
            return;
        }
        this.reviewNodes = data.rows || [];
        if (this.reviewNodes.length === 0) {
            this.modalError = 'No available nodes match this selection';
            await this.service.render();
            return;
        }
        if (this.isManualDirectProvisioning()) {
            this.applyManualDirectNodeNames();
            this.wizardStep = 5;
        } else {
            this.initializeRelaySelections();
            this.wizardStep = 3;
        }
        await this.service.render();
    }

    public async goStep4() {
        this.modalError = '';
        if (!this.isManualRelayProvisioning()) {
            this.applyManualDirectNodeNames();
            this.wizardStep = 5;
            await this.service.render();
            return;
        }
        this.initializeRelaySelections();
        const authorities = this.authorityNodes();
        if (authorities.length === 0) {
            this.modalError = 'Select authority nodes';
            return;
        }
        const usedSubnetKeys = new Set<string>();
        for (const authority of authorities) {
            const subnetKey = this.authoritySubnetKey(authority);
            if (!subnetKey) {
                this.modalError = 'Select subnet for every authority';
                return;
            }
            if (usedSubnetKeys.has(subnetKey)) {
                this.modalError = 'Select only one authority per subnet';
                return;
            }
            usedSubnetKeys.add(subnetKey);
        }
        this.ensureSelectedMemberAuthority();
        this.wizardStep = 4;
        await this.service.render();
    }

    public async goStep5() {
        this.modalError = '';
        if (!this.isManualRelayProvisioning()) {
            this.applyManualDirectNodeNames();
            this.wizardStep = 5;
            await this.service.render();
            return;
        }
        this.initializeRelaySelections();
        if (!this.buildRelayConfig()) {
            await this.service.render();
            return;
        }
        this.applyManualRelayNodeNames();
        this.wizardStep = 5;
        await this.service.render();
    }

    public async addCluster() {
        if (this.reviewNodes.length === 0) return;
        if (!this.validateReviewNodeNames()) {
            await this.service.render();
            return;
        }
        const provisioningMode = this.manualProvisioningMode();
        const relayConfig = provisioningMode === 'relay' ? this.buildRelayConfig() : null;
        if (provisioningMode === 'relay' && !relayConfig) return;
        const unassignedComputeNodes = provisioningMode === 'relay'
            ? this.lowerServerNodes().filter((node: any) => !this.lowerServerAuthorityNode(node))
            : [];
        if (unassignedComputeNodes.length > 0) {
            if (!confirm(this.unassignedComputeSaveMessage(unassignedComputeNodes))) return;
            relayConfig.allow_unassigned_compute = true;
            relayConfig.unassigned_compute_node_ids = unassignedComputeNodes.map((node: any) => node.id);
        }
        this.creating = true;
        this.modalError = '';
        const clusterName = String(this.newCluster.name || '').trim();
        const nodePrefix = provisioningMode === 'direct'
            ? String(this.newCluster.prefix || '').trim()
            : String(this.newCluster.compute_prefix || this.newCluster.prefix || '').trim();
        const relayPrefix = provisioningMode === 'relay' ? String(this.newCluster.relay_prefix || '').trim() : '';
        const computePrefix = provisioningMode === 'relay' ? nodePrefix : '';
        const bmcCredential = this.selectedBmcCredentialProfile();
        const payload = {
            ...this.newCluster,
            name: clusterName,
            provisioning_mode: provisioningMode,
            prefix: nodePrefix,
            relay_prefix: relayPrefix,
            compute_prefix: computePrefix,
            rack_unit: Number(this.newCluster.rack_unit || 1),
            node_ids: this.reviewNodes.map((node: any) => node.id),
            nodes_config: this.reviewNodes.map((node: any) => ({
                id: node.id,
                name: node.name,
            })),
            relay_config: relayConfig || {},
            relay_config_json: JSON.stringify(relayConfig || {}),
            require_relay_config: provisioningMode === 'relay',
            config: JSON.stringify({
                creation_mode: 'manual',
                provisioning_mode: provisioningMode,
                node_prefix: nodePrefix,
                relay_prefix: relayPrefix,
                compute_prefix: computePrefix,
                bmc_credential_id: bmcCredential?.id ?? '',
                bmc_credential_name: bmcCredential?.name || '',
            }),
        };
        const { code, data } = await wiz.call("create", { data: JSON.stringify(payload) });
        this.creating = false;
        if (code === 200) {
            this.showAddModal = false;
            this.resetWizard();
            await this.load();
        } else {
            this.modalError = data?.message || 'Failed to create cluster';
            await this.service.render();
        }
    }

    public async deleteCluster(item: any) {
        this.openActionId = null;
        const message = this.translate.instant('page.clusters.confirm_delete') || `Delete cluster ${item.name}?`;
        if (!confirm(message)) return;
        const { code } = await wiz.call("delete", { id: item.id });
        if (code === 200) await this.load(this.search.page);
    }

    public editCluster(item: any) {
        this.openActionId = null;
        this.viewCluster(item.id);
    }

    public async cloneCluster(item: any) {
        const config = this.clusterConfigObject(item);
        const deploymentMode = this.clusterDeploymentMode(item);
        const name = String(item?.name || 'cluster').trim();
        const bmcCredentialId = config.bmc_credential_id ?? '';
        this.openActionId = null;
        this.resetWizard();
        this.showAddModal = true;
        this.wizardMode = 'manual';
        this.wizardStep = 1;
        this.newCluster = {
            name: name ? `${name}-copy` : '',
            group_name: name ? `${name}-copy` : '',
            provisioning_mode: deploymentMode,
            prefix: String(config.node_prefix || item?.prefix || config.compute_prefix || '').trim(),
            relay_prefix: String(config.relay_prefix || '').trim(),
            compute_prefix: String(config.compute_prefix || item?.prefix || '').trim(),
            rack_unit: Number(item?.rack_unit || config.nodes_per_rack || 1) || 1,
        };
        if (deploymentMode === 'direct') {
            this.newCluster.compute_prefix = '';
            this.newCluster.relay_prefix = '';
        } else if (!this.newCluster.compute_prefix) {
            this.newCluster.compute_prefix = this.newCluster.prefix;
        }
        await this.loadWizardSources();
        if (this.availableBmcCredentialProfiles().some((profile: any) => String(profile.id) === String(bmcCredentialId))) {
            this.selectedBmcCredentialId = bmcCredentialId;
        }
        await this.service.render();
    }

    public viewCluster(id: number) {
        this.service.href('/kiera/clusters/' + id);
    }

    private clusterConfigObject(row: any): any {
        const raw = row?.config || '';
        if (raw && typeof raw === 'object') return raw;
        try {
            const parsed = JSON.parse(String(raw || '{}'));
            return parsed && typeof parsed === 'object' ? parsed : {};
        } catch (e) {
            return {};
        }
    }

    private clusterCreationMode(row: any): string {
        const config = this.clusterConfigObject(row);
        const mode = String(config.creation_mode || config.create_mode || '').trim().toLowerCase();
        if (mode === 'template' || mode === 'template_based') return 'template';
        if (mode === 'manual') return 'manual';
        if (config.template_file || config.template_preview || config.template_uploaded) return 'template';
        return 'manual';
    }

    public clusterCreationModeLabel(row: any): string {
        return this.clusterCreationMode(row) === 'template' ? 'Template' : 'Manual';
    }

    public clusterCreationModeBadgeClass(row: any): string {
        return this.clusterCreationMode(row) === 'template'
            ? 'bg-violet-50 text-violet-600 ring-1 ring-violet-100'
            : 'bg-indigo-50 text-indigo-600 ring-1 ring-indigo-100';
    }

    public clusterDisplayId(row: any): number {
        return Number(row?.display_id || row?.displayId || row?.sequence || row?.id || 0);
    }

    public clusterDeploymentMode(row: any): string {
        const config = this.clusterConfigObject(row);
        const mode = String(row?.deployment_type || config.provisioning_mode || config.deployment_type || '').trim().toLowerCase();
        if (mode.includes('relay') || mode.includes('릴레이') || mode.includes('중계')) return 'relay';
        if (mode.includes('direct') || mode.includes('직접')) return 'direct';
        return this.clusterRelayServerCount(row) > 0 ? 'relay' : 'direct';
    }

    public clusterDeploymentLabel(row: any): string {
        return this.clusterDeploymentMode(row) === 'relay' ? 'Relay 기반' : 'Direct 기반';
    }

    public clusterDeploymentIcon(row: any): string {
        return this.clusterDeploymentMode(row) === 'relay' ? 'bx-git-branch' : 'bx-down-arrow-alt';
    }

    public clusterDeploymentBadgeClass(row: any): string {
        return this.clusterDeploymentMode(row) === 'relay'
            ? 'bg-emerald-50 text-emerald-700 ring-1 ring-emerald-100'
            : 'bg-orange-50 text-orange-600 ring-1 ring-orange-100';
    }

    private clusterMappingSummary(row: any): any {
        const config = this.clusterConfigObject(row);
        const mapping = config.mapping_summary || {};
        const previewSummary = config.template_preview?.summary || {};
        return { ...previewSummary, ...mapping };
    }

    public clusterRelayServerCount(row: any): number {
        const summary = this.clusterMappingSummary(row);
        const value = row?.relay_server_count ?? row?.relay_count ?? summary.relay ?? summary.relay_count ?? 0;
        return Math.max(0, Number(value || 0));
    }

    public clusterComputeNodeCount(row: any): number {
        const summary = this.clusterMappingSummary(row);
        const explicit = row?.compute_node_count ?? row?.compute_count ?? summary.compute_count;
        if (explicit !== undefined && explicit !== null && explicit !== '') {
            return Math.max(0, Number(explicit || 0));
        }
        const computed = Number(summary.compute_pre || 0) + Number(summary.compute_auto || 0);
        if (computed > 0) return computed;
        const total = Number(row?.count || 0);
        return this.clusterDeploymentMode(row) === 'relay' ? Math.max(0, total - this.clusterRelayServerCount(row)) : Math.max(0, total);
    }

    public clusterCreatedDate(row: any): string {
        const created = String(row?.created || '').trim();
        if (!created) return '-';
        return created.split(/[T ]/)[0] || created;
    }

    public clusterCreatedTime(row: any): string {
        const created = String(row?.created || '').trim();
        if (!created) return '';
        const time = created.includes('T') ? created.split('T')[1] : created.split(' ')[1];
        return String(time || '').replace(/\.\d+$/, '').replace(/Z$/, '');
    }

    public toggleGroup(groupId: number) {
        this.expandedGroups[groupId] = !this.expandedGroups[groupId];
    }

    public includeGroup(group: any) {
        this.removeGroup('exclude', group.id);
        this.nodeFilter.include.group[group.id] = group.name;
    }

    public excludeGroup(group: any) {
        this.removeGroup('include', group.id);
        this.nodeFilter.exclude.group[group.id] = group.name;
    }

    public includeRack(group: any, rack: number) {
        this.removeRack('exclude', group.id, rack);
        if (!this.nodeFilter.include.rack[group.id]) this.nodeFilter.include.rack[group.id] = {};
        this.nodeFilter.include.rack[group.id][rack] = group.name;
    }

    public excludeRack(group: any, rack: number) {
        this.removeRack('include', group.id, rack);
        if (!this.nodeFilter.exclude.rack[group.id]) this.nodeFilter.exclude.rack[group.id] = {};
        this.nodeFilter.exclude.rack[group.id][rack] = group.name;
    }

    public includeZone(zone: any) {
        this.removeZone('exclude', zone.id);
        this.nodeFilter.include.zone[zone.id] = zone.name;
    }

    public excludeZone(zone: any) {
        this.removeZone('include', zone.id);
        this.nodeFilter.exclude.zone[zone.id] = zone.name;
    }

    public includeNode(node: any) {
        this.removeNode('exclude', node.id);
        this.nodeFilter.include.node[node.id] = node.name;
    }

    public excludeNode(node: any) {
        this.removeNode('include', node.id);
        this.nodeFilter.exclude.node[node.id] = node.name;
    }

    public removeGroup(mode: string, groupId: any) {
        delete this.nodeFilter[mode].group[groupId];
    }

    public removeRack(mode: string, groupId: any, rack: any) {
        if (!this.nodeFilter[mode].rack[groupId]) return;
        delete this.nodeFilter[mode].rack[groupId][rack];
        if (Object.keys(this.nodeFilter[mode].rack[groupId]).length === 0) {
            delete this.nodeFilter[mode].rack[groupId];
        }
    }

    public removeNode(mode: string, nodeId: any) {
        delete this.nodeFilter[mode].node[nodeId];
    }

    public removeZone(mode: string, zoneId: any) {
        delete this.nodeFilter[mode].zone[zoneId];
    }

    private initializeRelaySelections() {
        const nodeIds = new Set(this.reviewNodes.map((node: any) => String(node.id)));
        Object.keys(this.authoritySelection).forEach((nodeId: string) => {
            if (!nodeIds.has(nodeId)) delete this.authoritySelection[nodeId];
        });
        Object.keys(this.authoritySubnetSelection).forEach((nodeId: string) => {
            if (!nodeIds.has(nodeId)) delete this.authoritySubnetSelection[nodeId];
        });
        Object.keys(this.memberSelection).forEach((nodeId: string) => {
            if (!nodeIds.has(nodeId)) delete this.memberSelection[nodeId];
        });
        Object.keys(this.memberAuthoritySelection).forEach((nodeId: string) => {
            if (!nodeIds.has(nodeId)) delete this.memberAuthoritySelection[nodeId];
        });
        Object.keys(this.lowerAuthoritySelection).forEach((nodeId: string) => {
            if (!nodeIds.has(nodeId)) delete this.lowerAuthoritySelection[nodeId];
        });
        for (const node of this.reviewNodes) {
            const nodeId = String(node.id);
            if (this.authoritySelection[nodeId] === undefined) {
                this.authoritySelection[nodeId] = false;
            }
            if (!this.authoritySubnetSelection[nodeId]) {
                this.authoritySubnetSelection[nodeId] = this.nodeSubnetKey(node);
            }
            if (this.authoritySelection[nodeId]) {
                this.memberSelection[nodeId] = false;
                delete this.memberAuthoritySelection[nodeId];
                delete this.lowerAuthoritySelection[nodeId];
            } else {
                this.memberSelection[nodeId] = !!this.memberAuthoritySelection[nodeId];
            }
        }
        const authorityIds = new Set(this.authorityNodes().map((node: any) => String(node.id)));
        Object.keys(this.memberAuthoritySelection).forEach((nodeId: string) => {
            const authorityId = String(this.memberAuthoritySelection[nodeId] || '');
            if (!authorityIds.has(authorityId)) {
                delete this.memberAuthoritySelection[nodeId];
                this.memberSelection[nodeId] = false;
            }
        });
        Object.keys(this.lowerAuthoritySelection).forEach((nodeId: string) => {
            const authorityId = String(this.lowerAuthoritySelection[nodeId] || '');
            if (!authorityIds.has(authorityId)) {
                delete this.lowerAuthoritySelection[nodeId];
            }
        });
        if (authorityIds.size === 1) {
            const authorityId = Array.from(authorityIds)[0];
            for (const node of this.reviewNodes) {
                const nodeId = String(node.id || '');
                if (this.authoritySelection[nodeId] || this.memberAuthoritySelection[nodeId]) continue;
                if (!this.lowerAuthoritySelection[nodeId]) {
                    this.lowerAuthoritySelection[nodeId] = authorityId;
                }
            }
        }
        this.ensureSelectedMemberAuthority();
    }

    public wizardStepTitle(): string {
        const manualTitles: any = {
            0: 'Create cluster method',
            1: 'Cluster information',
            2: 'Select nodes',
            3: 'Select authority',
            4: 'Select members',
            5: 'Review node names',
        };
        const templateTitles: any = {
            0: 'Create cluster method',
            1: 'Template Upload',
            2: 'Import Validation',
            3: 'Cluster Information',
            4: 'Node Mapping',
            5: 'Create Cluster',
        };
        const titles = this.wizardMode === 'manual' ? manualTitles : templateTitles;
        return titles[this.wizardStep] || '';
    }

    public isAuthorityNode(node: any): boolean {
        return !!this.authoritySelection[String(node?.id || '')];
    }

    public isMemberNode(node: any): boolean {
        return !this.isAuthorityNode(node) && !!this.memberAuthorityNode(node);
    }

    public onAuthorityChanged(node: any, event: any) {
        const nodeId = String(node?.id || '');
        const checked = !!event?.target?.checked;
        this.authoritySelection[nodeId] = checked;
        if (checked) {
            this.memberSelection[nodeId] = false;
            delete this.memberAuthoritySelection[nodeId];
            delete this.lowerAuthoritySelection[nodeId];
            if (!this.authoritySubnetSelection[nodeId]) {
                this.authoritySubnetSelection[nodeId] = this.nodeSubnetKey(node);
            }
            if (!this.selectedAuthorityNodeId) {
                this.selectedAuthorityNodeId = nodeId;
            }
        } else {
            this.memberSelection[nodeId] = false;
            Object.keys(this.memberAuthoritySelection).forEach((memberNodeId: string) => {
                if (String(this.memberAuthoritySelection[memberNodeId] || '') === nodeId) {
                    delete this.memberAuthoritySelection[memberNodeId];
                    this.memberSelection[memberNodeId] = false;
                }
            });
            Object.keys(this.lowerAuthoritySelection).forEach((lowerNodeId: string) => {
                if (String(this.lowerAuthoritySelection[lowerNodeId] || '') === nodeId) {
                    delete this.lowerAuthoritySelection[lowerNodeId];
                }
            });
            if (this.selectedAuthorityNodeId === nodeId) {
                this.selectedAuthorityNodeId = '';
            }
        }
        this.ensureSelectedMemberAuthority();
    }

    public onMemberChanged(node: any, event: any) {
        const nodeId = String(node?.id || '');
        if (this.isAuthorityNode(node)) return;
        const checked = !!event?.target?.checked;
        if (checked) {
            this.ensureSelectedMemberAuthority();
            const authorityId = String(this.lowerAuthoritySelection[nodeId] || '');
            const authority = this.authorityNodes().find((item: any) => String(item.id) === authorityId) || this.selectedMemberAuthority();
            if (!authority) return;
            this.memberAuthoritySelection[nodeId] = String(authority.id);
            delete this.lowerAuthoritySelection[nodeId];
        } else {
            const authorityId = String(this.memberAuthoritySelection[nodeId] || '');
            delete this.memberAuthoritySelection[nodeId];
            if (authorityId) this.lowerAuthoritySelection[nodeId] = authorityId;
        }
        this.memberSelection[nodeId] = !!this.memberAuthoritySelection[nodeId];
    }

    public onAuthoritySubnetChanged(node: any) {
        if (!node) return;
        const nodeId = String(node.id || '');
        this.authoritySubnetSelection[nodeId] = this.authoritySubnetKey(node);
    }

    public authorityNodes(): any[] {
        return (this.reviewNodes || []).filter((node: any) => this.isAuthorityNode(node));
    }

    public candidateMemberNodes(): any[] {
        return (this.reviewNodes || []).filter((node: any) => !this.isAuthorityNode(node));
    }

    public selectedMemberNodes(): any[] {
        return this.candidateMemberNodes().filter((node: any) => this.isMemberNode(node));
    }

    public lowerServerNodes(): any[] {
        return this.candidateMemberNodes().filter((node: any) => !this.isMemberNode(node));
    }

    private ensureSelectedMemberAuthority() {
        const authorities = this.authorityNodes();
        if (authorities.length === 0) {
            this.selectedAuthorityNodeId = '';
            return;
        }
        const selectedId = String(this.selectedAuthorityNodeId || '');
        if (!authorities.some((authority: any) => String(authority.id) === selectedId)) {
            this.selectedAuthorityNodeId = String(authorities[0].id);
        }
    }

    public selectedMemberAuthority(): any {
        this.ensureSelectedMemberAuthority();
        const selectedId = String(this.selectedAuthorityNodeId || '');
        return this.authorityNodes().find((authority: any) => String(authority.id) === selectedId) || null;
    }

    public isSelectedMemberAuthority(authority: any): boolean {
        return String(authority?.id || '') === String(this.selectedAuthorityNodeId || '');
    }

    public selectMemberAuthority(authority: any) {
        if (!authority) return;
        this.selectedAuthorityNodeId = String(authority.id || '');
    }

    public toggleMemberForSelectedAuthority(node: any) {
        if (!node || this.isAuthorityNode(node)) return;
        this.ensureSelectedMemberAuthority();
        const nodeId = String(node.id || '');
        if (this.isMemberNode(node)) {
            const authorityId = String(this.memberAuthoritySelection[nodeId] || '');
            delete this.memberAuthoritySelection[nodeId];
            if (authorityId) this.lowerAuthoritySelection[nodeId] = authorityId;
        } else {
            const authority = this.lowerServerAuthorityNode(node) || this.selectedMemberAuthority();
            if (!authority) return;
            const authorityId = String(authority.id || '');
            this.memberAuthoritySelection[nodeId] = authorityId;
            delete this.lowerAuthoritySelection[nodeId];
        }
        this.memberSelection[nodeId] = !!this.memberAuthoritySelection[nodeId];
    }

    public candidateAuthorityId(node: any): string {
        const nodeId = String(node?.id || '');
        if (!nodeId || this.isAuthorityNode(node)) return '';
        if (this.isMemberNode(node)) {
            return String(this.memberAuthoritySelection[nodeId] || '');
        }
        return String(this.lowerAuthoritySelection[nodeId] || '');
    }

    public onCandidateAuthorityChanged(node: any, authorityId: any) {
        if (!node || this.isAuthorityNode(node)) return;
        const nodeId = String(node.id || '');
        const normalizedAuthorityId = String(authorityId || '');
        const exists = this.authorityNodes().some((authority: any) => String(authority.id) === normalizedAuthorityId);
        if (this.isMemberNode(node)) {
            if (exists) this.memberAuthoritySelection[nodeId] = normalizedAuthorityId;
            else delete this.memberAuthoritySelection[nodeId];
            this.memberSelection[nodeId] = !!this.memberAuthoritySelection[nodeId];
            return;
        }
        if (exists) this.lowerAuthoritySelection[nodeId] = normalizedAuthorityId;
        else delete this.lowerAuthoritySelection[nodeId];
    }

    public nodeSubnetKey(node: any): string {
        const subnetId = String(node?.dhcp_domain_subnet_id || '').trim();
        if (subnetId) return `id:${subnetId}`;
        const key = String(node?.dhcp_domain_key || '').trim();
        if (key) return key;
        const vlanId = String(node?.dhcp_domain_vlan_id || '').trim();
        if (vlanId && vlanId !== '0') return `vlan:${vlanId}`;
        const cidr = String(node?.dhcp_domain_cidr || '').trim();
        if (cidr) return `cidr:${cidr}`;
        return '';
    }

    public nodeSubnetLabel(node: any): string {
        const label = String(node?.dhcp_domain_label || '').trim();
        if (label) return label;
        const subnet = this.relaySubnetForKey(this.nodeSubnetKey(node));
        if (subnet) return subnet.label;
        return this.nodeSubnetKey(node) || '-';
    }

    private subnetKeyFallbackLabel(key: any): string {
        const text = String(key || '').trim();
        if (!text) return '-';
        if (text.startsWith('id:')) return `Subnet #${text.split(':', 2)[1] || '-'}`;
        if (text.startsWith('vlan:')) return `VLAN ${text.split(':', 2)[1] || '-'}`;
        if (text.startsWith('cidr:') || text.includes('/')) return 'Subnet';
        return text;
    }

    private nodeAuthoritySubnetOptionLabel(node: any): string {
        const key = this.nodeSubnetKey(node);
        const subnet = this.relaySubnetForKey(key);
        if (subnet) return subnet.label;
        return this.subnetKeyFallbackLabel(key);
    }

    public relaySubnetForKey(key: any): any {
        const normalized = String(key || '').trim();
        if (!normalized) return null;
        const lower = normalized.toLowerCase();
        return (this.relaySubnets || []).find((subnet: any) => {
            const candidates = [
                subnet?.key,
                subnet?.name,
                subnet?.label,
                subnet?.cidr,
                subnet?.id ? `id:${subnet.id}` : '',
                subnet?.id,
                subnet?.cidr ? `cidr:${subnet.cidr}` : '',
                subnet?.vlan_id && String(subnet.vlan_id) !== '0' ? `vlan:${subnet.vlan_id}` : '',
            ];
            return candidates.some((value: any) => String(value || '').trim().toLowerCase() === lower);
        }) || null;
    }

    public authoritySubnetKey(node: any): string {
        const nodeId = String(node?.id || '');
        return String(this.authoritySubnetSelection[nodeId] || '').trim() || this.nodeSubnetKey(node);
    }

    public authoritySubnetLabel(node: any): string {
        const subnet = this.relaySubnetForKey(this.authoritySubnetKey(node));
        if (subnet) return subnet.label;
        return this.subnetKeyFallbackLabel(this.authoritySubnetKey(node));
    }

    public relaySubnetDhcpRangeLabel(subnet: any): string {
        if (!subnet) return '-';
        const explicit = String(subnet?.dhcp_range_label || '').trim();
        if (explicit) return explicit;
        const start = String(subnet?.dhcp_start || '').trim();
        const end = String(subnet?.dhcp_end || '').trim();
        if (start && end) return `${start} - ${end}`;
        return start || end || '-';
    }

    public authoritySubnetDhcpRangeLabel(node: any): string {
        if (!this.isAuthorityNode(node)) return '-';
        const subnet = this.relaySubnetForKey(this.authoritySubnetKey(node));
        return this.relaySubnetDhcpRangeLabel(subnet);
    }

    public authoritySubnetOptions(node: any): any[] {
        const options = [...(this.relaySubnets || [])];
        const nodeKey = this.nodeSubnetKey(node);
        if (nodeKey && !options.some((subnet: any) => String(subnet.key || '') === nodeKey)) {
            options.unshift({ key: nodeKey, label: this.nodeAuthoritySubnetOptionLabel(node) });
        }
        return options;
    }

    private ipAddressToNumber(value: any): number | null {
        const text = String(value || '').trim();
        const parts = text.split('.');
        if (parts.length !== 4) return null;
        let result = 0;
        for (const part of parts) {
            if (!/^\d+$/.test(part)) return null;
            const value = Number(part);
            if (value < 0 || value > 255) return null;
            result = (result * 256) + value;
        }
        return result;
    }

    public memberAuthorityNode(node: any): any {
        if (!node || this.isAuthorityNode(node)) return null;
        const authorityId = String(this.memberAuthoritySelection[String(node.id || '')] || '');
        if (!authorityId) return null;
        return this.authorityNodes().find((authority: any) => String(authority.id) === authorityId) || null;
    }

    public lowerServerAuthorityNode(node: any): any {
        if (!node || this.isAuthorityNode(node) || this.isMemberNode(node)) return null;
        const authorityId = String(this.lowerAuthoritySelection[String(node.id || '')] || '');
        if (!authorityId) return null;
        return this.authorityNodes().find((authority: any) => String(authority.id) === authorityId) || null;
    }

    public memberAuthorityLabel(node: any): string {
        const authority = this.memberAuthorityNode(node);
        return authority ? `${authority.name || authority.original_name || 'Node'} (#${authority.id})` : 'Unmatched';
    }

    public lowerServerAuthorityLabel(node: any): string {
        const authority = this.lowerServerAuthorityNode(node);
        return authority ? `${authority.name || authority.original_name || 'Node'} (#${authority.id})` : 'Unassigned';
    }

    public candidateAuthorityNode(node: any): any {
        return this.isMemberNode(node) ? this.memberAuthorityNode(node) : this.lowerServerAuthorityNode(node);
    }

    public candidateAuthorityLabel(node: any): string {
        const authority = this.candidateAuthorityNode(node);
        if (authority) return `${authority.name || authority.original_name || 'Node'} (#${authority.id})`;
        return 'Unassigned';
    }

    public candidateAuthoritySubnetLabel(node: any): string {
        const authority = this.candidateAuthorityNode(node);
        return authority ? this.authoritySubnetLabel(authority) : '-';
    }

    public candidateAuthoritySubnetDhcpRangeLabel(node: any): string {
        const authority = this.candidateAuthorityNode(node);
        if (!authority) return '-';
        const subnet = this.relaySubnetForKey(this.authoritySubnetKey(authority));
        return this.relaySubnetDhcpRangeLabel(subnet);
    }

    public authorityMemberCount(authority: any): number {
        return this.selectedMemberNodes().filter((node: any) => {
            const assigned = this.memberAuthorityNode(node);
            return String(assigned?.id || '') === String(authority?.id || '');
        }).length;
    }

    private manualDirectPrefix(): string {
        return String(this.newCluster?.prefix || '').trim();
    }

    private manualRelayPrefix(): string {
        return String(this.newCluster?.relay_prefix || '').trim();
    }

    private manualComputePrefix(): string {
        return String(this.newCluster?.compute_prefix || this.newCluster?.prefix || '').trim();
    }

    private manualHostname(prefix: string, sequence: number): string {
        const text = String(prefix || '').trim();
        if (!text) return '';
        return `${text}${sequence}`;
    }

    private sortNodesByBmcIp(nodes: any[]): any[] {
        return [...(nodes || [])].sort((a: any, b: any) => {
            const aIp = this.ipAddressToNumber(a?.bmc_ip);
            const bIp = this.ipAddressToNumber(b?.bmc_ip);
            if (aIp === null && bIp !== null) return 1;
            if (aIp !== null && bIp === null) return -1;
            if (aIp !== null && bIp !== null && aIp !== bIp) return aIp - bIp;
            return Number(a?.id || 0) - Number(b?.id || 0);
        });
    }

    private applyManualDirectNodeNames() {
        const nodePrefix = this.manualDirectPrefix();
        if (!nodePrefix) return;
        const nodes = this.sortNodesByBmcIp(this.reviewNodes || []);
        nodes.forEach((node: any, index: number) => {
            node.name = this.manualHostname(nodePrefix, index + 1);
        });
    }

    private manualRelaySequenceByNodeId(): any {
        const sequenceByNodeId: any = {};
        const relayNodes = this.sortNodesByBmcIp([
            ...this.authorityNodes(),
            ...this.selectedMemberNodes(),
        ]);
        relayNodes.forEach((node: any, index: number) => {
            sequenceByNodeId[String(node.id)] = index + 1;
        });
        return sequenceByNodeId;
    }

    private applyManualRelayNodeNames() {
        const relayPrefix = this.manualRelayPrefix();
        const computePrefix = this.manualComputePrefix();
        if (!relayPrefix && !computePrefix) return;

        const relaySequenceByNodeId = this.manualRelaySequenceByNodeId();
        const relayNodes = this.sortNodesByBmcIp([
            ...this.authorityNodes(),
            ...this.selectedMemberNodes(),
        ]);
        for (const node of relayNodes) {
            const sequence = relaySequenceByNodeId[String(node.id)];
            if (relayPrefix && sequence) node.name = this.manualHostname(relayPrefix, sequence);
        }

        const lowerServers = this.sortNodesByBmcIp(this.lowerServerNodes());
        lowerServers.forEach((node: any, index: number) => {
            if (computePrefix) node.name = this.manualHostname(computePrefix, index + 1);
        });
    }

    private validateReviewNodeNames(): boolean {
        this.modalError = '';
        if (this.reviewNodes.length === 0) {
            this.modalError = 'Select nodes';
            return false;
        }
        const names = new Set<string>();
        for (const node of this.reviewNodes) {
            const name = String(node.name || '').trim();
            if (!name) {
                this.modalError = 'Enter node names';
                return false;
            }
            const normalized = name.toLowerCase();
            if (names.has(normalized)) {
                this.modalError = `Duplicate node name: ${name}`;
                return false;
            }
            names.add(normalized);
            node.name = name;
        }
        return true;
    }

    public autoClassifyMemberNodes() {
        for (const node of this.candidateMemberNodes()) {
            this.memberSelection[String(node.id)] = !!this.memberAuthoritySelection[String(node.id)];
        }
    }

    private buildRelayConfig(): any {
        this.modalError = '';
        if (!this.isManualRelayProvisioning()) {
            return null;
        }
        this.initializeRelaySelections();
        const authorities = this.authorityNodes();
        if (authorities.length === 0) {
            this.modalError = 'Select authority nodes';
            return null;
        }
        const subnetKeys = new Set<string>();
        for (const authority of authorities) {
            const subnetKey = this.authoritySubnetKey(authority);
            if (!subnetKey) {
                this.modalError = 'Select subnet for every authority';
                return null;
            }
            if (subnetKeys.has(subnetKey)) {
                this.modalError = 'Select only one authority per subnet';
                return null;
            }
            subnetKeys.add(subnetKey);
        }

        const members = this.selectedMemberNodes();
        const lowerServers = this.lowerServerNodes();
        return {
            authorities: authorities.map((node: any) => ({
                node_id: node.id,
                dhcp_group_key: this.authoritySubnetKey(node),
            })),
            member_node_ids: members.map((node: any) => node.id),
            member_assignments: members.map((node: any) => {
                const authority = this.memberAuthorityNode(node);
                return {
                    node_id: node.id,
                    authority_node_id: authority?.id || '',
                    dhcp_group_key: authority ? this.authoritySubnetKey(authority) : '',
                };
            }),
            lower_node_ids: lowerServers.map((node: any) => node.id),
            lower_assignments: lowerServers.map((node: any) => {
                const authority = this.lowerServerAuthorityNode(node);
                if (!authority) return null;
                return {
                    node_id: node.id,
                    authority_node_id: authority.id,
                    dhcp_group_key: this.authoritySubnetKey(authority),
                };
            }).filter((row: any) => !!row),
            unassigned_compute_node_ids: lowerServers
                .filter((node: any) => !this.lowerServerAuthorityNode(node))
                .map((node: any) => node.id),
        };
    }

    public hasNodeSelection(): boolean {
        const include = this.nodeFilter.include;
        return Object.keys(include.group).length > 0 ||
            Object.keys(include.rack).length > 0 ||
            Object.keys(include.zone).length > 0 ||
            Object.keys(include.node).length > 0;
    }

    public filteredNodes(): any[] {
        const filters = this.singleFilters;
        return this.selectableNodes.filter((node: any) => {
            if (filters.bmc_type && String(node.bmc_type || '') !== String(filters.bmc_type)) return false;
            if (filters.status && String(node.status || '') !== String(filters.status)) return false;
            if (filters.group_id && String(node.group_id || '') !== String(filters.group_id)) return false;
            if (filters.rack && String(node.rack || '') !== String(filters.rack)) return false;
            return true;
        });
    }

    public statusOptions(): string[] {
        return this.uniqueOptions('status');
    }

    public bmcTypeOptions(): string[] {
        return this.uniqueOptions('bmc_type');
    }

    private uniqueOptions(field: string): string[] {
        const values = this.selectableNodes
            .map((node: any) => String(node[field] || '').trim())
            .filter((value: string) => !!value);
        return Array.from(new Set(values)).sort();
    }

    public selectedGroupRacks(): number[] {
        const groupId = Number(this.singleFilters.group_id || 0);
        const group = this.groups.find((item: any) => Number(item.id) === groupId);
        const rackCount = Math.max(0, Number(group?.racks || 0));
        const racks: number[] = [];
        for (let rack = 1; rack <= rackCount; rack++) racks.push(rack);
        return racks;
    }

    public groupRacks(group: any): number[] {
        const rackCount = Math.max(1, Number(group?.racks || 1));
        const racks: number[] = [];
        for (let rack = 1; rack <= rackCount; rack++) racks.push(rack);
        return racks;
    }

    public selectionEntries(mode: string, type: string): any[] {
        return Object.entries(this.nodeFilter[mode][type] || {}).map(([key, value]: [string, any]) => ({ key, value }));
    }

    public rackSelectionEntries(mode: string): any[] {
        const result: any[] = [];
        const rackGroups = this.nodeFilter[mode].rack || {};
        Object.entries(rackGroups).forEach(([groupId, racks]: [string, any]) => {
            Object.entries(racks || {}).forEach(([rack, groupName]: [string, any]) => {
                result.push({ groupId, rack, groupName });
            });
        });
        return result;
    }

    public totalPages() {
        return Math.ceil(this.total / this.search.dump) || 1;
    }

    public pageList() {
        const tp = this.totalPages();
        const current = this.search.page;
        const pages: number[] = [];
        const start = Math.max(1, current - 2);
        const end = Math.min(tp, current + 2);
        for (let i = start; i <= end; i++) pages.push(i);
        return pages;
    }

    public async changePageSize() {
        this.search.page = 1;
        await this.load(1);
    }

    public async sort(field: string) {
        if (this.sortField === field) {
            this.sortDir = this.sortDir === 'asc' ? 'desc' : 'asc';
        } else {
            this.sortField = field;
            this.sortDir = 'asc';
        }
        this.sortList();
        await this.service.render();
    }

    private sortList() {
        const field = this.sortField;
        const dir = this.sortDir === 'asc' ? 1 : -1;
        this.list.sort((a: any, b: any) => {
            let va = a[field];
            let vb = b[field];
            if (va == null) va = '';
            if (vb == null) vb = '';
            if (['id', 'display_id', 'count', 'relay_server_count', 'compute_node_count'].includes(field)) return (Number(va) - Number(vb)) * dir;
            return String(va).localeCompare(String(vb)) * dir;
        });
    }

    public getSortIcon(field: string): string {
        if (this.sortField !== field) return 'bx-sort-alt-2';
        return this.sortDir === 'asc' ? 'bx-sort-up' : 'bx-sort-down';
    }
}

export default PageKieraClustersComponent;
